import ContactCard from "../components/utility/contactCard";
import globalStyles from "../assets/styles/global.module.scss";
import textTypeFileIcon from "../assets/images/icons/txtFileType.png";
import csvTypeFileIcon from "../assets/images/icons/csvFileType.png";
import mdTypeFileIcon from "../assets/images/icons/mdFileType.png";
import xmlTypeFileIcon from "../assets/images/icons/xmlFileType.png";
import pngTypeFileIcon from "../assets/images/icons/pngFileType.png";
import jpgTypeFileIcon from "../assets/images/icons/jpgFileType.png";
import jsonTypeFileIcon from "../assets/images/icons/jsonFileType.png";
import jpegTypeFileIcon from "../assets/images/icons/jpegFileType.png";
import genericFileType from "../assets/images/icons/genericFileType.png";
import IconsColor from "../components/utility/iconsColor";
import moment from "moment-timezone";
import styles from '../assets/styles/componentStyles/chatbotStyles/chats.module.scss'
import whatsappIcon from '../assets/Whatsapp.svg'
import instagramIcon from '../assets/images/channels/instagram/instagram.png';
import facebookIcon from '../assets/images/channels/facebook/facebookMessenger.svg'
import zohoIcon from "../assets/images/channels/zoho/zoho.svg";
import chronoxIcon from "../assets/images/global/Chronox AI Icon.png"
import { v4 as uuidv4 } from 'uuid';
import { primaryColor, secondaryColor } from "./colors";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import getStartedPageIcon from "./../assets/images/getStarted/getStartedPageIcon.png"
import { getVendorField } from "./whiteLabelling";
import { useGenericStore } from "../store/genericStore";
import { CHATBOT_CHANNEL_NAME } from "../pages/ruleBasedInbox/channelConstants";

export const SiteKey = "6Ld0tIgnAAAAAM6flWQfozA41EW4o13PRW78EILx";
export const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const userNameRegex = /^[a-z ,.'-]+$/i;
export const flagUseGemini = false;
export const emptyUserDetail = {
    flagUser: null,
    timezone_id: 0,
    timezone_name: "",
    timezone_hour: "",
    timezone_standard_name: "",
    flag_user_anonymous: null,
    flag_email_verified: null,
    user_id: 0,
    user_type: "",
    user_first_name: "",
    user_last_name: "",
    user_email: "",
    user_assignment_id: 0,
    user_phone_number: "",
    user_status: {
        user_status_id: 0,
        user_status_name: ""
    },
    user_popup_actions: [],
    plan_detail: null,
    user_role: {
        user_role_id: 0,
        user_role_name: ""
    },
    user_organization_data: null
};

export const API_ROUTES_PERMISSIONS = {
    AI_CHATBOT_MANAGE: 'ai-chatbot.manage',
    STATIC_WORKFLOW_MANAGE: 'static-wf.manage',
    CHANNELS_READ: 'channels.read',
    CHANNELS_MANAGE: 'channels.manage',
    DATA_CONNECTORE_READ: 'data-connector.read',
    DATA_CONNECTORE_MANAGE: 'data-connector.manage',
    ANALYTICS_READ: 'analytics.read',
    ANALYTICS_MANAGE: 'analytics.manage',
    CALL_ANALYSIS_MANAGE: 'call-analysis.manage',
    CAMPAIGN_READ: 'campaign.read',
    CAMPAIGN_MANAGE: 'campaign.manage',
    INBOX_READ: 'inbox.read',
    INBOX_UPDATE: 'inbox.update',
    INBOX_ADMIN: 'inbox.admin',
    GLOBAL_READ: 'global.read',
    GLOBAL_MANAGE: 'global.manage',
    DEVPORTAL_MANAGE: 'devportal.manage',
    PUBLIC: 'public',
    USER_LOGGED_IN: 'user-logged-in',
    HELPDESK_MANAGE: 'helpdesk.manage',
    HELPDESK_READ: 'helpdesk.read',
    HELPDESK_ADMIN: 'helpdesk.admin',
    EXTERNAL_WEBHOOK_MANAGE: 'external-webhook.manage',
    PRODUCTS_READ: 'products.read',
    PRODUCTS_MANAGE: 'products.manage',
    CONTACTS_READ: 'contacts.read',
    CONTACTS_MANAGE: 'contacts.manage',
    ORGANIZATION_MANAGE: 'organization.manage',
    VOICE_AI_CHATBOT_MANAGE: 'voice-ai-chatbot.manage',
    ORGANIZATION_TEAM_MANAGE: 'organization-team.manage',
    ORGANIZATION_TEAM_READ: 'organization-team.read',
    PRICING_MANAGE: 'pricing.manage',
    ALL: 'all'
}

export const getApiRoutePermission = (apiRoutesPermissionAssignment, permissionName) => {
    return apiRoutesPermissionAssignment?.find((permission) => permission?.api_routes_permission_name === permissionName);
}

export const hasPermission = (apiRoutesPermissionAssignment, permissionName) => {
    return getApiRoutePermission(apiRoutesPermissionAssignment, permissionName);
}

export const getStartedPageObj = {
    menuName: "Get Started",
    menuKey: "get-started",
    flagHeaderKey: true,
    navigationLink: `/get-started`,
    imgSrc: <img src={getStartedPageIcon} height={18} width={18} color="#4C4A4D"  />,
    whiteImgSrc: <img src={getStartedPageIcon} height={18} width={18} color={primaryColor}  />,
    coloredImgSrc: <img src={getStartedPageIcon} height={18} width={18} color="#000000"  />,
};

export const hasAIChatbotPageAccess = (apiRoutesPermissionAssignment, userDetail) => {
    if(!userDetail?.user_assignment_role_data?.length) return true;
    if(hasPermission(apiRoutesPermissionAssignment, API_ROUTES_PERMISSIONS["AI_CHATBOT_MANAGE"]) || hasPermission(apiRoutesPermissionAssignment, API_ROUTES_PERMISSIONS["ALL"])){
        return true;
    }
    return false;
}

export const hasDashboardPageReadAccess = (apiRoutesPermissionAssignment, userDetail) => {
    if(!userDetail?.user_assignment_role_data?.length) return true;
    if(hasPermission(apiRoutesPermissionAssignment, API_ROUTES_PERMISSIONS["USER_LOGGED_IN"]) || hasPermission(apiRoutesPermissionAssignment, API_ROUTES_PERMISSIONS["ALL"])){
        return true;
    }
    return false;
}

export const hasCampaignPageReadAccess = (apiRoutesPermissionAssignment, userDetail) => {
    if(!userDetail?.user_assignment_role_data?.length) return true;
    if(hasPermission(apiRoutesPermissionAssignment, API_ROUTES_PERMISSIONS["CAMPAIGN_READ"]) || hasPermission(apiRoutesPermissionAssignment, API_ROUTES_PERMISSIONS["ALL"])){
        return true;
    }

    return false;
}

export const hasCampaignManageAccess = (apiRoutesPermissionAssignment, userDetail) => {
    if(!userDetail?.user_assignment_role_data?.length) return true;
    if(hasPermission(apiRoutesPermissionAssignment, API_ROUTES_PERMISSIONS["CAMPAIGN_MANAGE"]) || hasPermission(apiRoutesPermissionAssignment, API_ROUTES_PERMISSIONS["ALL"])){
        return true;
    }
    return false;
}

export const hasRuleBasedChatbotPageAccess = (apiRoutesPermissionAssignment, userDetail) => {
    if(!userDetail?.user_assignment_role_data?.length) return true;
    if(hasPermission(apiRoutesPermissionAssignment, API_ROUTES_PERMISSIONS["STATIC_WORKFLOW_MANAGE"]) || hasPermission(apiRoutesPermissionAssignment, API_ROUTES_PERMISSIONS["ALL"])){
        return true;
    }
    return false;
}

export const hasVoiceAgentPageReadAccess = (apiRoutesPermissionAssignment, userDetail) => {
    if(!userDetail?.user_assignment_role_data?.length) return true;
    if(hasPermission(apiRoutesPermissionAssignment, API_ROUTES_PERMISSIONS["AI_CHATBOT_MANAGE"]) || hasPermission(apiRoutesPermissionAssignment, API_ROUTES_PERMISSIONS["INBOX_READ"]) || hasPermission(apiRoutesPermissionAssignment, API_ROUTES_PERMISSIONS["ALL"])){
        return true;
    }
    return false;
}

export const hasVoiceAgentManagePermission = (apiRoutesPermissionAssignment, userDetail) => {
    if(!userDetail?.user_assignment_role_data?.length) return true;
     if(hasPermission(apiRoutesPermissionAssignment, API_ROUTES_PERMISSIONS["AI_CHATBOT_MANAGE"]) || hasPermission(apiRoutesPermissionAssignment, API_ROUTES_PERMISSIONS["ALL"])){
        return true;
    }
    return false;
}

export const hasOrderDetailsPageReadAccess = (apiRoutesPermissionAssignment, userDetail) => {
    // if(isAdmin(userDetail) && process.env.REACT_APP_ENV === "staging"){
        if(!userDetail?.user_assignment_role_data?.length) return true;
        if(hasPermission(apiRoutesPermissionAssignment, API_ROUTES_PERMISSIONS["AI_CHATBOT_MANAGE"]) || hasPermission(apiRoutesPermissionAssignment, API_ROUTES_PERMISSIONS["ALL"])){
            return true;
        }
    // } 
    return false;
}

export const hasContactPageReadAccess = (apiRoutesPermissionAssignment, userDetail) => {
    if(!userDetail?.user_assignment_role_data?.length) return true;
    if(hasPermission(apiRoutesPermissionAssignment, API_ROUTES_PERMISSIONS['CONTACTS_READ']) || hasPermission(apiRoutesPermissionAssignment, API_ROUTES_PERMISSIONS['ALL'])){
        return true;
    }
    return false;
}

export const hasContactManageAccess = (apiRoutesPermissionAssignment, userDetail) => {
    if(!userDetail?.user_assignment_role_data?.length) return true;
    if(hasPermission(apiRoutesPermissionAssignment, API_ROUTES_PERMISSIONS['CONTACTS_MANAGE']) || hasPermission(apiRoutesPermissionAssignment, API_ROUTES_PERMISSIONS['ALL'])){
        return true;
    }
    return false;
}

export const hasCustomAPIPageReadAccess = (apiRoutesPermissionAssignment, userDetail) => {
    if(!userDetail?.user_assignment_role_data?.length) return true;
    if(hasPermission(apiRoutesPermissionAssignment, API_ROUTES_PERMISSIONS['DATA_CONNECTORE_READ']) || hasPermission(apiRoutesPermissionAssignment, API_ROUTES_PERMISSIONS['ALL'])){
        return true;
    }
    return false;
}

export const hasCustomAPIPageManageAccess = (apiRoutesPermissionAssignment, userDetail) => {
    if(!userDetail?.user_assignment_role_data?.length) return true;
    if(hasPermission(apiRoutesPermissionAssignment, API_ROUTES_PERMISSIONS['DATA_CONNECTORE_MANAGE']) || hasPermission(apiRoutesPermissionAssignment, API_ROUTES_PERMISSIONS['ALL'])){
        return true;
    }
    return false;
}

export const hasIntentPageReadAccess = (apiRoutesPermissionAssignment, userDetail) => {
    if(!userDetail?.user_assignment_role_data?.length) return true;
    if(hasPermission(apiRoutesPermissionAssignment, API_ROUTES_PERMISSIONS['USER_LOGGED_IN']) || hasPermission(apiRoutesPermissionAssignment, API_ROUTES_PERMISSIONS['ALL'])){
        return true;
    }
    return false;
}

export const hasIntentManageAccess = (apiRoutesPermissionAssignment, userDetail) => {
    if(!userDetail?.user_assignment_role_data?.length) return true;
    if(hasPermission(apiRoutesPermissionAssignment, API_ROUTES_PERMISSIONS['STATIC_WORKFLOW_MANAGE']) || hasPermission(apiRoutesPermissionAssignment, API_ROUTES_PERMISSIONS['ALL'])){
        return true;
    }
    return false;
}

export const hasProductPageReadAccess = (apiRoutesPermissionAssignment, userDetail) => {
    if(!userDetail?.user_assignment_role_data?.length) return true;
    if(hasPermission(apiRoutesPermissionAssignment, API_ROUTES_PERMISSIONS['PRODUCTS_READ']) || hasPermission(apiRoutesPermissionAssignment, API_ROUTES_PERMISSIONS['ALL'])){
        return true;
    }
    return false;
}

export const hasProductManageAccess = (apiRoutesPermissionAssignment, userDetail) => {
    if(!userDetail?.user_assignment_role_data?.length) return true;
    if(hasPermission(apiRoutesPermissionAssignment, API_ROUTES_PERMISSIONS['PRODUCTS_MANAGE']) || hasPermission(apiRoutesPermissionAssignment, API_ROUTES_PERMISSIONS['ALL'])){
        return true;
    }
    return false;
}

export const hasCallAnalysisPageAccess = (apiRoutesPermissionAssignment, userDetail) => {
    if(!userDetail?.user_assignment_role_data?.length) return true;
    if(hasPermission(apiRoutesPermissionAssignment, API_ROUTES_PERMISSIONS['CALL_ANALYSIS_MANAGE']) || hasPermission(apiRoutesPermissionAssignment, API_ROUTES_PERMISSIONS['ALL'])){
        return true;
    }
    return false;
}

export const hasSupportTicketPageAccess = (apiRoutesPermissionAssignment, userDetail) => {
    if(!userDetail?.user_assignment_role_data?.length) return true;
    if(hasPermission(apiRoutesPermissionAssignment, API_ROUTES_PERMISSIONS['PUBLIC']) || hasPermission(apiRoutesPermissionAssignment, API_ROUTES_PERMISSIONS['ALL'])){
        return true;
    }
    return false;
}

export const hasChannelsPageReadAccess = (apiRoutesPermissionAssignment, userDetail) => {
    if(!userDetail?.user_assignment_role_data?.length) return true;
    if(hasPermission(apiRoutesPermissionAssignment, API_ROUTES_PERMISSIONS['CHANNELS_READ']) || hasPermission(apiRoutesPermissionAssignment, API_ROUTES_PERMISSIONS['ALL'])
    ) {
        return true;
    }
    return false;
}

export const hasChannelsManageAccess = (apiRoutesPermissionAssignment, userDetail) => {
    if(!userDetail?.user_assignment_role_data?.length) return true;
    if(hasPermission(apiRoutesPermissionAssignment, API_ROUTES_PERMISSIONS['CHANNELS_MANAGE']) || hasPermission(apiRoutesPermissionAssignment, API_ROUTES_PERMISSIONS['ALL'])){
        return true;
    }
    return false;
}

export const hasCustomRecipientManageAccess = (apiRoutesPermissionAssignment, userDetail) => {
    if(!userDetail?.user_assignment_role_data?.length) return true;
    if(hasPermission(apiRoutesPermissionAssignment, API_ROUTES_PERMISSIONS['USER_LOGGED_IN']) || hasPermission(apiRoutesPermissionAssignment, API_ROUTES_PERMISSIONS['ALL'])){
        return true;
    }
    return false;
}

export const hasTemplateManageAccess = (apiRoutesPermissionAssignment, userDetail) => {
    if(!userDetail?.user_assignment_role_data?.length) return true;
    if(hasPermission(apiRoutesPermissionAssignment, API_ROUTES_PERMISSIONS['CHANNELS_MANAGE'])   || hasPermission(apiRoutesPermissionAssignment, API_ROUTES_PERMISSIONS['ALL'])){
        return true;
    }
    return false;
}

export const hasFlowManageAccess = (apiRoutesPermissionAssignment, userDetail) => {
    if(!userDetail?.user_assignment_role_data?.length) return true;
    if(hasPermission(apiRoutesPermissionAssignment, API_ROUTES_PERMISSIONS['CHANNELS_MANAGE'])   || hasPermission(apiRoutesPermissionAssignment, API_ROUTES_PERMISSIONS['ALL'])){
        return true;
    }
    return false;
}

export const hasCarouselTemplateGroupManageAccess = (apiRoutesPermissionAssignment, userDetail) => {
    if(!userDetail?.user_assignment_role_data?.length) return true;
    if(hasPermission(apiRoutesPermissionAssignment, API_ROUTES_PERMISSIONS['CHANNELS_MANAGE'])   || hasPermission(apiRoutesPermissionAssignment, API_ROUTES_PERMISSIONS['ALL'])){
        return true;
    }
    return false;
}

export const hasInboxReadAccess = (apiRoutesPermissionAssignment, userDetail) => {
    if(!userDetail?.user_assignment_role_data?.length) return true;
    if(hasPermission(apiRoutesPermissionAssignment, API_ROUTES_PERMISSIONS['INBOX_READ']) || hasPermission(apiRoutesPermissionAssignment, API_ROUTES_PERMISSIONS['ALL'])){
        return true;
    }
    return false;
}

export const hasInboxUpdateAccess = (apiRoutesPermissionAssignment, userDetail) => {
    if(!userDetail?.user_assignment_role_data?.length) return true;
    if(hasPermission(apiRoutesPermissionAssignment, API_ROUTES_PERMISSIONS['INBOX_UPDATE']) || hasPermission(apiRoutesPermissionAssignment, API_ROUTES_PERMISSIONS['ALL'])){
        return true;
    }
    return false;
}

export const hasInboxAdminAccess = (apiRoutesPermissionAssignment, userDetail) => {
    if(!userDetail?.user_assignment_role_data?.length) return true;
    if(hasPermission(apiRoutesPermissionAssignment, API_ROUTES_PERMISSIONS['INBOX_ADMIN']) || hasPermission(apiRoutesPermissionAssignment, API_ROUTES_PERMISSIONS['ALL'])){
        return true;
    }
    return false;
}

export const hasOrganizationTeamManageAccess = (apiRoutesPermissionAssignment, userDetail) => {
    if(userDetail?.user_assignment_role_data?.length){
        if(hasPermission(apiRoutesPermissionAssignment, API_ROUTES_PERMISSIONS['ORGANIZATION_TEAM_MANAGE']) || hasPermission(apiRoutesPermissionAssignment, API_ROUTES_PERMISSIONS['ALL'])){
            return true;
        }
        return false;
    }
    else {
        const effectiveUserRoleName = userDetail?.user_organization_data?.user_organization_role_name?.toLowerCase();
        const allowedRoles = [
            ORGANIZATION_ROLES['ADMIN_ROLE']?.toLowerCase(),
            ORGANIZATION_ROLES['OWNER_ROLE']?.toLowerCase(),
        ];

        return allowedRoles?.includes(effectiveUserRoleName);
    }
}

export const hasViewDetailedLogBtnAccess = (userDetail) => {
    if(isAdmin(userDetail)){
        return true;
    }

    const userAssignmentRole = userDetail?.user_assignment_role_data;

    if(!userAssignmentRole?.length){
        return isOrganizationRoleAdminOrOwnerOrMember(userDetail);
    }

    const userAssignmentRoleName = userAssignmentRole?.[0]?.chronox_user_role_name?.toLowerCase();
    const restrictedUserRolesForViewDetailedLogBtn = [USER_ASSIGNMENT_ROLES["AGENT_ROLE"]?.toLowerCase(), USER_ASSIGNMENT_ROLES["AGENT_ADMIN_ROLE"]?.toLowerCase()];

    return !restrictedUserRolesForViewDetailedLogBtn.includes(userAssignmentRoleName);
}

export const hasUserLoggedInPermission = (apiRoutesPermissionAssignment, userDetail) => {
    if(!userDetail?.user_assignment_role_data?.length) return true;
    if(hasPermission(apiRoutesPermissionAssignment, API_ROUTES_PERMISSIONS['USER_LOGGED_IN']) || hasPermission(apiRoutesPermissionAssignment, API_ROUTES_PERMISSIONS['ALL'])){
        return true;
    }
    return false;
}

export const hasAIChatbotManageAccess = (apiRoutesPermissionAssignment, userDetail) => {
    if(!userDetail?.user_assignment_role_data?.length) return true;
    if(hasPermission(apiRoutesPermissionAssignment, API_ROUTES_PERMISSIONS['AI_CHATBOT_MANAGE']) || hasPermission(apiRoutesPermissionAssignment, API_ROUTES_PERMISSIONS['ALL'])){
        return true;
    }
    return false;
}

export const hasWebhookManageAccess = (apiRoutesPermissionAssignment, userDetail) => {
    if(!userDetail?.user_assignment_role_data?.length) return true;
    if(hasPermission(apiRoutesPermissionAssignment, API_ROUTES_PERMISSIONS['EXTERNAL_WEBHOOK_MANAGE']) || hasPermission(apiRoutesPermissionAssignment, API_ROUTES_PERMISSIONS['ALL'])){
        return true;
    }
    return false;
}

export const hasOrganizationManageAccess = (apiRoutesPermissionAssignment, userDetail) => {
    if(!userDetail?.user_assignment_role_data?.length) return true;
    if(hasPermission(apiRoutesPermissionAssignment, API_ROUTES_PERMISSIONS['ORGANIZATION_MANAGE']) || hasPermission(apiRoutesPermissionAssignment, API_ROUTES_PERMISSIONS['ALL'])){
        return true;
    }
    return false;
}

export const hasApiKeyPageAccess = (apiRoutesPermissionAssignment, userDetail) => {
    const effectiveUserRole = getEffectiveUserRoleName(userDetail);
    const allowedRoles = [ORGANIZATION_ROLES['OWNER_ROLE']?.toLowerCase(), ORGANIZATION_ROLES['ADMIN_ROLE']?.toLowerCase(), USER_ASSIGNMENT_ROLES['ADMIN_ROLE']?.toLowerCase(), USER_ASSIGNMENT_ROLES['OWNER_ROLE']?.toLowerCase(), USER_ASSIGNMENT_ROLES['DEVELOPER_ROLE']?.toLowerCase(), USER_ASSIGNMENT_ROLES['SUPER_OWNER_ROLE']?.toLowerCase()];
    
    if(allowedRoles?.includes(effectiveUserRole)){
        return hasUserLoggedInPermission(apiRoutesPermissionAssignment, userDetail);
    } 
    return false;
}

export const hasTicketSubstatusManageAccess = (userDetail) => {
    const effectiveUserRole = getEffectiveUserRoleName(userDetail);

    const notAllowedRoles = [ORGANIZATION_ROLES['AGENT_ROLE']?.toLowerCase(), USER_ASSIGNMENT_ROLES['AGENT_ROLE']?.toLowerCase()];
    if(notAllowedRoles?.includes(effectiveUserRole)){
        return false;
    }
    return true;
}

export const hasBillingPlan = (userDetail) => {
    return userDetail?.org_billing_plan_data != null;
}

export const hasBillingUsageManageAccess = (apiRoutesPermissionAssignment, userDetail, vendorData) => {
    // Vendors are not allowed to manage billing usage
    if(isVendor(vendorData, userDetail)){
        return false;
    }
    
    // Billing usage management is not allowed for these organization IDs (clients + vendors)
    // if(restrictedOrganizationIdsForBillingUsageManage.includes(userDetail.user_organization_data?.organization_id)){
    //     return false;
    // }
    
    if(!hasBillingPlan(userDetail)){
        return false;
    }

    // New Role based access
    if(userDetail?.user_assignment_role_data?.length) {
        if(hasPermission(apiRoutesPermissionAssignment, API_ROUTES_PERMISSIONS['PRICING_MANAGE']) || hasPermission(apiRoutesPermissionAssignment, API_ROUTES_PERMISSIONS['ALL'])){
            return true;
        }
        return false;
    } else {
        // Old Role based access
        const effectiveUserRole = getEffectiveUserRoleName(userDetail);
        const allowedRoles = [ORGANIZATION_ROLES['OWNER_ROLE']?.toLowerCase(), ORGANIZATION_ROLES['ADMIN_ROLE']?.toLowerCase()];
    
        return allowedRoles?.includes(effectiveUserRole);
    }
}

export const usePublicMenuItems = (userDetail, apiRoutesPermissionAssignment) => { 
    // const vendorData = useContext(UserContext)?.vendorData;
    // const vendorField = getVendorField(vendorData, "backend api", process.env.REACT_APP_BASE_URL);

    return [  
    ...(hasDashboardPageReadAccess(apiRoutesPermissionAssignment, userDetail) ? [
        {
            menuName: "Dashboard",
            menuKey: "dashboard",
            navigationLink: "/dashboard",
            imgSrc: <IconsColor fillColor="#4C4A4D" iconName="dashboardPageIcon" height={"20"} width={"20"} />,
            whiteImgSrc: <IconsColor fillColor={primaryColor} iconName="dashboardPageIcon" height={"20"} width={"20"} />,
            coloredImgSrc: <IconsColor fillColor="#000000" iconName="dashboardPageIcon" height={"20"} width={"20"} />,
        }
    ] : []),
    ...(hasInboxReadAccess(apiRoutesPermissionAssignment, userDetail) ? [
        {
            menuName: "Inbox",
            menuKey: "inbox",
            navigationLink: "/inbox",
            imgSrc: <IconsColor fillColor="#4C4A4D" iconName="chat" />,
            whiteImgSrc: <IconsColor fillColor={primaryColor} iconName="chat" />,
            coloredImgSrc: <IconsColor fillColor="#000000" iconName="chat" />,
        }
    ] : []),
    ...(hasCampaignPageReadAccess(apiRoutesPermissionAssignment, userDetail) ? [
        {
            menuName: "WhatsApp Campaign",
            menuKey: "campaign",
            navigationLink: "/whatsappcampaign",
            imgSrc: <IconsColor fillColor="#4C4A4D" iconName="campaignIcon" height={"18"} width={"18"} />,
            whiteImgSrc: <IconsColor fillColor={primaryColor} iconName="campaignIcon" height={"18"} width={"18"} />,
            coloredImgSrc: <IconsColor fillColor="#000000" iconName="campaignIcon" height={"18"} width={"18"} />,
            subMenu: [
                {
                    menuName: "Campaign",
                    menuKey: "whatsappCampaign",
                    navigationLink: "/whatsappcampaign",
                    imgSrc: <IconsColor fillColor="#4C4A4D" iconName="whatsappcampaign" height={"18"} width={"18"} />,
                    whiteImgSrc: <IconsColor fillColor={primaryColor} iconName="whatsappcampaign" height={"18"} width={"18"} />,
                    coloredImgSrc: <IconsColor fillColor="#000000" iconName="whatsappcampaign" height={"18"} width={"18"} />,
                },
                {
                    menuName: "Dashboard",
                    menuKey: "whatsappCampaignDashboard",
                    navigationLink: "/whatsappcampaign/dashboard",
                    imgSrc: <IconsColor fillColor="#4C4A4D" iconName="camapignDashboard" height={"18"} width={"18"} />,
                    whiteImgSrc: <IconsColor fillColor={primaryColor} iconName="camapignDashboard" height={"18"} width={"18"} />,
                    coloredImgSrc: <IconsColor fillColor="#000000" iconName="camapignDashboard" height={"18"} width={"18"} />,
                }
            ]
        }
    ] : []),
    // {
    //     menuName: "Dashboard",
    //     menuKey: "home",
    //     navigationLink: "/insights",
    //     imgSrc: <IconsColor fillColor="#4C4A4D" iconName="insights" height={"18"} width={"18"} />,
    //     whiteImgSrc: <IconsColor fillColor={primaryColor} iconName="insights" height={"18"} width={"18"} />,  
    //     coloredImgSrc: <IconsColor fillColor="#000000" iconName="insights" height={"18"} width={"18"} />,
    // }, //this was created with static data for GITEX only 
    
    ...(hasRuleBasedChatbotPageAccess(apiRoutesPermissionAssignment, userDetail) ? [
        {
            menuName: "Rule-Based Chatbot",
            menuKey: "workFlow",
            navigationLink: "/workflow",
            flagHidden: false,
            imgSrc: <IconsColor fillColor="#4C4A4D" iconName="workflow" height={"20"} width={"20"} />,
            whiteImgSrc: <IconsColor fillColor={primaryColor} iconName="workflow" height={"20"} width={"20"} />,
            coloredImgSrc: <IconsColor fillColor="#000000" iconName="workflow" height={"20"} width={"20"} />,
        }
    ] : []),
    ...(hasAIChatbotPageAccess(apiRoutesPermissionAssignment, userDetail) ? [
        {
            menuName: "AI Chatbot",
            menuKey: "chatbot",
            navigationLink: "/chatbot",
            imgSrc: <IconsColor fillColor="#4C4A4D" iconName="chatbot" />,
            whiteImgSrc: <IconsColor fillColor={primaryColor} iconName="chatbot" />,
            coloredImgSrc: <IconsColor fillColor="#000000" iconName="chatbot" />,
        }
    ] : []),
    ...(hasVoiceAgentPageReadAccess(apiRoutesPermissionAssignment, userDetail) ? [
        {
            menuName: "Voice Agent",
            menuKey: "voiceagent",
            navigationLink: "/voiceagent",
            imgSrc: <IconsColor fillColor="#4C4A4D" iconName="voiceAgent" width="20" height="20" />,
            whiteImgSrc: <IconsColor fillColor={primaryColor} iconName="voiceAgent" width="20" height="20" />,
            coloredImgSrc: <IconsColor fillColor="#000000" iconName="voiceAgent" width="20" height="20" />,
        }
    ] : []),
    // ...(vendorField === "https://api-dev.chronox.ai" ? [
    ...(hasOrderDetailsPageReadAccess(apiRoutesPermissionAssignment, userDetail) ? [
        {
            menuName: "Order Details",
            menuKey: "orderDetails",
            navigationLink: "/orderDetails",
            imgSrc: <IconsColor fillColor="#4C4A4D" iconName="sendOrderDetailTemplate" height={"18"} width={"18"} />,
            whiteImgSrc: <IconsColor fillColor={primaryColor} iconName="sendOrderDetailTemplate" height={"18"} width={"18"} />,
            coloredImgSrc: <IconsColor fillColor="#000000" iconName="sendOrderDetailTemplate" height={"18"} width={"18"} />,
        }
    ] : []),
    ...(hasUserLoggedInPermission(apiRoutesPermissionAssignment, userDetail) ? [
        {
            menuName: "Conversion Leads",
            menuKey: "conversionLeads",
            navigationLink: "/conversionLeads",
            imgSrc: <IconsColor fillColor="#4C4A4D" iconName="leadGeneration" height={"18"} width={"18"} />,
            whiteImgSrc: <IconsColor fillColor={primaryColor} iconName="leadGeneration" height={"18"} width={"18"} />,
            coloredImgSrc: <IconsColor fillColor="#000000" iconName="leadGeneration" height={"18"} width={"18"} />,
        }
    ] : []),
    {
        menuName: "Show More/Less",
        menuKey: "showMoreLess",
        navigationLink: "/viewMore",
        imgSrc: <MoreVertIcon sx={{ color: "#4C4A4D", height: "18px", width: "18px"}} />,
        whiteImgSrc: <MoreVertIcon sx={{ color: primaryColor, height: "18px", width: "18px"}} />,
        coloredImgSrc: <MoreVertIcon sx={{ color: "#000000", height: "18px", width: "18px"}} />,
        subMenu: [
            ...(hasContactPageReadAccess(apiRoutesPermissionAssignment, userDetail) ? [
                {
                    menuName: "Contacts",
                    menuKey: "contacts",
                    navigationLink: "/contacts",
                    imgSrc: <IconsColor fillColor="#4C4A4D" iconName="contacts" height={"18"} width={"18"} />,
                    whiteImgSrc: <IconsColor fillColor={primaryColor} iconName="contacts" height={"18"} width={"18"} />,
                    coloredImgSrc: <IconsColor fillColor="#000000" iconName="contacts" height={"18"} width={"18"} />,
                }
            ] : []),
            ...(hasChannelsPageReadAccess(apiRoutesPermissionAssignment, userDetail) ? [
                {
                    menuName: "Channels",
                    menuKey: "channels",
                    navigationLink: `/channels`,
                    imgSrc: <IconsColor fillColor="#4C4A4D" iconName="integration" />,
                    whiteImgSrc: <IconsColor fillColor={primaryColor} iconName="integration" />,
                    coloredImgSrc: <IconsColor fillColor="#000000" iconName="integration" />,
                }
            ] : []),
            ...(hasWebhookManageAccess(apiRoutesPermissionAssignment, userDetail) ? [
                {
                    menuName: "Webhook",
                    menuKey: "Webhook",
                    navigationLink: "/webhook",
                    flagHidden: false,
                    imgSrc: <IconsColor fillColor="#4C4A4D" iconName="webhookIcon" height={"20"} width={"20"} />,
                    whiteImgSrc: <IconsColor fillColor={primaryColor} iconName="webhookIcon" height={"20"} width={"20"} />,
                    coloredImgSrc: <IconsColor fillColor="#000000" iconName="webhookIcon" height={"20"} width={"20"} />,
                }
            ] : []),
            ...(hasCustomAPIPageReadAccess(apiRoutesPermissionAssignment, userDetail) ? [
                {
                    menuName: "Custom API",
                    menuKey: "customAPI",
                    navigationLink: "/customAPI",
                    flagHidden: false,
                    imgSrc: <IconsColor fillColor="#4C4A4D" iconName="custom_api" height={"20"} width={"20"} />,
                    whiteImgSrc: <IconsColor fillColor={primaryColor} iconName="custom_api" height={"20"} width={"20"} />,
                    coloredImgSrc: <IconsColor fillColor="#000000" iconName="custom_api" height={"20"} width={"20"} />,
                }
            ] : []),
            ...(hasIntentPageReadAccess(apiRoutesPermissionAssignment, userDetail) ? [
                {
                    menuName: "Intent",
                    menuKey: "Intent",
                    navigationLink: "/intent",
                    flagHidden: false,
                    imgSrc: <IconsColor fillColor="#4C4A4D" iconName="intent" height={"20"} width={"20"} />,
                    whiteImgSrc: <IconsColor fillColor={primaryColor} iconName="intent" height={"20"} width={"20"} />,
                    coloredImgSrc: <IconsColor fillColor="#000000" iconName="intent" height={"20"} width={"20"} />,
                }
            ] : []),
            ...(hasProductPageReadAccess(apiRoutesPermissionAssignment, userDetail) ? [
                {
                    menuName: "Product",
                    menuKey: "Product",
                    navigationLink: "/product",
                    flagHidden: false,
                    imgSrc: <IconsColor fillColor="#4C4A4D" iconName="productPageIcon" height={"20"} width={"20"} />,
                    whiteImgSrc: <IconsColor fillColor={primaryColor} iconName="productPageIcon" height={"20"} width={"20"} />,
                    coloredImgSrc: <IconsColor fillColor="#000000" iconName="productPageIcon" height={"20"} width={"20"} />,
                }
            ] : []),
            ...(hasAIChatbotPageAccess(apiRoutesPermissionAssignment, userDetail) ? [
                {
                    menuName: "Knowledge Base",
                    menuKey: "knowledgeBase",
                    navigationLink: "/knowledge-base",
                    flagHidden: false,
                    imgSrc: <IconsColor fillColor="#4C4A4D" iconName="knowledgeBaseIcon" height={"20"} width={"20"} />,
                    whiteImgSrc: <IconsColor fillColor={primaryColor} iconName="knowledgeBaseIcon" height={"20"} width={"20"} />,
                    coloredImgSrc: <IconsColor fillColor="#000000" iconName="knowledgeBaseIcon" height={"20"} width={"20"} />,
                }
            ] : [])
            // The Call Analysis page is disabled as it is a client-specific custom feature.
            // ...(hasCallAnalysisPageAccess(apiRoutesPermissionAssignment, userDetail) ? [
            //     {
            //         menuName: "Call Analysis",
            //         menuKey: "callanalysis",
            //         navigationLink: `/callanalysis`,
            //         imgSrc: <IconsColor fillColor="#4C4A4D" iconName="callAnalysis" height="16" width="16" />,
            //         whiteImgSrc: <IconsColor fillColor={primaryColor} iconName="callAnalysis" height="16" width="16" />,
            //         coloredImgSrc: <IconsColor fillColor="#000000" iconName="callAnalysis" height="16" width="16" />,
            //     }
            // ] : []),
            // ...(hasSupportTicketPageAccess(apiRoutesPermissionAssignment, userDetail) ? [
            //     {
            //         menuName: "Support Tickets",
            //         menuKey: "supportTicket",
            //         navigationLink: "/supportTicket",
            //         imgSrc: <IconsColor fillColor="#4C4A4D" iconName="feedback" />,
            //         whiteImgSrc: <IconsColor fillColor={primaryColor} iconName="feedback" />,
            //         coloredImgSrc: <IconsColor fillColor="#000000" iconName="feedback" />,
            //     }
            // ] : [])
        ]
    },
    // {(window.location.pathname.toLowerCase() !== "/callanalysis" && window.location.pathname.toLowerCase() !== "/callanalysis/list") && callRecordsData && callRecordsData.call_center && callRecordsData.call_center.length > 0 &&
    //     <MenuItem
    //         className={styles.menuLogout}
    //         onMouseEnter={() => setHoveredMenu("callanalysis")}
    //         onMouseLeave={() => setHoveredMenu("")}
    //         onClick={() => { handleOnClick() }}
    //     >
    //         <ListItemIcon>
    //             {hoveredMenu === "callanalysis" ? <IconsColor height={"17"} width={"17"} fillColor={"#000000"} iconName="callAnalysis" /> : <IconsColor height={"17"} width={"17"} fillColor={{primaryColor}} iconName="callAnalysis" />}
    //         </ListItemIcon>
    //         Call Analysis
    //     </MenuItem>
    // }

    // {
    //     menuName: "Organization",
    //     menuKey: "organization",
    //     navigationLink: `/organization`,
    //     imgSrc: <IconsColor fillColor="#4C4A4D" iconName="organization" />,
    //     whiteImgSrc: <IconsColor fillColor={primaryColor} iconName="organization" />,
    //     coloredImgSrc: <IconsColor fillColor="#000000" iconName="organization" />,
    // },
    // {
    //     menuName: "Settings",
    //     menuKey: "settings",
    //     navigationLink: "/settings-accountDetails",
    //     imgSrc: <IconsColor fillColor="#4C4A4D" iconName="settings" />,
    //     whiteImgSrc: <IconsColor fillColor="#ffffff" iconName="settings" />,
    //     coloredImgSrc: <IconsColor fillColor={primaryColor} iconName="settings" />,
    // }

    ]
}

export const publicAgentMenuItems = [
    {
        menuName: "Dashboard",
        menuKey: "dashboard",
        navigationLink: "/dashboard",
        imgSrc: <IconsColor fillColor="#4C4A4D" iconName="dashboardPageIcon" height={"20"} width={"20"} />,
        whiteImgSrc: <IconsColor fillColor={primaryColor} iconName="dashboardPageIcon" height={"20"} width={"20"} />,
        coloredImgSrc: <IconsColor fillColor="#000000" iconName="dashboardPageIcon" height={"20"} width={"20"} />,
    }, 
    {
        menuName: "Inbox",
        menuKey: "inbox",
        navigationLink: "/inbox",
        imgSrc: <IconsColor fillColor="#4C4A4D" iconName="chat" />,
        whiteImgSrc: <IconsColor fillColor={primaryColor} iconName="chat" />,
        coloredImgSrc: <IconsColor fillColor="#000000" iconName="chat" />,
    },
]
export const menuItemsJunagadh = [ 
    {
        menuName: "Dashboard",
        menuKey: "dashboard",
        navigationLink: "/dashboard",
        imgSrc: <IconsColor fillColor="#4C4A4D" iconName="dashboardPageIcon" height={"20"} width={"20"} />,
        whiteImgSrc: <IconsColor fillColor={primaryColor} iconName="dashboardPageIcon" height={"20"} width={"20"} />,
        coloredImgSrc: <IconsColor fillColor="#000000" iconName="dashboardPageIcon" height={"20"} width={"20"} />,
    },  
    {
        menuName: "Inbox",
        menuKey: "inbox",
        navigationLink: "/inbox",
        imgSrc: <IconsColor fillColor="#4C4A4D" iconName="chat" />,
        whiteImgSrc: <IconsColor fillColor={primaryColor} iconName="chat" />,
        coloredImgSrc: <IconsColor fillColor="#000000" iconName="chat" />,
    },
    {
        menuName: "WhatsApp Campaign",
        menuKey: "campaign",
        navigationLink: "/whatsappcampaign",
        imgSrc: <IconsColor fillColor="#4C4A4D" iconName="campaignIcon" height={"18"} width={"18"} />,
        whiteImgSrc: <IconsColor fillColor={primaryColor} iconName="campaignIcon" height={"18"} width={"18"} />,
        coloredImgSrc: <IconsColor fillColor="#000000" iconName="campaignIcon" height={"18"} width={"18"} />,
        subMenu: [
            {
                menuName: "Campaign",
                menuKey: "whatsappCampaign",
                navigationLink: "/whatsappcampaign",
                imgSrc: <IconsColor fillColor="#4C4A4D" iconName="whatsappcampaign" height={"18"} width={"18"} />,
                whiteImgSrc: <IconsColor fillColor={primaryColor} iconName="whatsappcampaign" height={"18"} width={"18"} />,
                coloredImgSrc: <IconsColor fillColor="#000000" iconName="whatsappcampaign" height={"18"} width={"18"} />,
            },
            {
                menuName: "Dashboard",
                menuKey: "whatsappCampaignDashboard",
                navigationLink: "/whatsappcampaign/dashboard",
                imgSrc: <IconsColor fillColor="#4C4A4D" iconName="camapignDashboard" height={"18"} width={"18"} />,
                whiteImgSrc: <IconsColor fillColor={primaryColor} iconName="camapignDashboard" height={"18"} width={"18"} />,
                coloredImgSrc: <IconsColor fillColor="#000000" iconName="camapignDashboard" height={"18"} width={"18"} />,
            },
        ]
    },
    // {
    //     menuName: "Dashboard",
    //     menuKey: "analytics",
    //     navigationLink: "/analytics",
    //     imgSrc: <IconsColor fillColor="#4C4A4D" iconName="insights" height={"18"} width={"18"} />,
    //     whiteImgSrc: <IconsColor fillColor={primaryColor} iconName="insights" height={"18"} width={"18"} />,
    //     coloredImgSrc: <IconsColor fillColor="#000000" iconName="insights" height={"18"} width={"18"} />,
    // },
    {
        menuName: "Rule-Based Chatbot",
        menuKey: "workFlow",
        navigationLink: "/workflow",
        flagHidden: false,
        imgSrc: <IconsColor fillColor="#4C4A4D" iconName="workflow" height={"20"} width={"20"} />,
        whiteImgSrc: <IconsColor fillColor={primaryColor} iconName="workflow" height={"20"} width={"20"} />,
        coloredImgSrc: <IconsColor fillColor="#000000" iconName="workflow" height={"20"} width={"20"} />,
    },
    {
        menuName: "Order Details",
        menuKey: "orderDetails",
        navigationLink: "/orderDetails",
        imgSrc: <IconsColor fillColor="#4C4A4D" iconName="sendOrderDetailTemplate" height={"18"} width={"18"} />,
        whiteImgSrc: <IconsColor fillColor={primaryColor} iconName="sendOrderDetailTemplate" height={"18"} width={"18"} />,
        coloredImgSrc: <IconsColor fillColor="#000000" iconName="sendOrderDetailTemplate" height={"18"} width={"18"} />,
    }, 
    {
        menuName: "Show More/Less",
        menuKey: "showMoreLess",
        navigationLink: "/viewMore",
        imgSrc: <MoreVertIcon sx={{ color: "#4C4A4D", height: "18px", width: "18px"}} />,
        whiteImgSrc: <MoreVertIcon sx={{ color: primaryColor, height: "18px", width: "18px"}} />,
        coloredImgSrc: <MoreVertIcon sx={{ color: "#000000", height: "18px", width: "18px"}} />,
        subMenu: [
            {
                menuName: "Contacts",
                menuKey: "contacts",
                navigationLink: "/contacts",
                imgSrc: <IconsColor fillColor="#4C4A4D" iconName="contacts" height={"18"} width={"18"} />,
                whiteImgSrc: <IconsColor fillColor={primaryColor} iconName="contacts" height={"18"} width={"18"} />,
                coloredImgSrc: <IconsColor fillColor="#000000" iconName="contacts" height={"18"} width={"18"} />,
            },
            {
                menuName: "Channels",
                menuKey: "channels",
                navigationLink: `/channels`,
                imgSrc: <IconsColor fillColor="#4C4A4D" iconName="integration" />,
                whiteImgSrc: <IconsColor fillColor={primaryColor} iconName="integration" />,
                coloredImgSrc: <IconsColor fillColor="#000000" iconName="integration" />,
            },
            {
                menuName: "Webhook",
                menuKey: "Webhook",
                navigationLink: "/webhook",
                flagHidden: false,
                imgSrc: <IconsColor fillColor="#4C4A4D" iconName="webhookIcon" height={"20"} width={"20"} />,
                whiteImgSrc: <IconsColor fillColor={primaryColor} iconName="webhookIcon" height={"20"} width={"20"} />,
                coloredImgSrc: <IconsColor fillColor="#000000" iconName="webhookIcon" height={"20"} width={"20"} />,
            },  
            {
                menuName: "Custom API",
                menuKey: "customAPI",
                navigationLink: "/customAPI",
                flagHidden: false,
                imgSrc: <IconsColor fillColor="#4C4A4D" iconName="custom_api" height={"20"} width={"20"} />,
                whiteImgSrc: <IconsColor fillColor={primaryColor} iconName="custom_api" height={"20"} width={"20"} />,
                coloredImgSrc: <IconsColor fillColor="#000000" iconName="custom_api" height={"20"} width={"20"} />,
            },
            {
                menuName: "Intent",
                menuKey: "Intent",
                navigationLink: "/intent",
                flagHidden: false,
                imgSrc: <IconsColor fillColor="#4C4A4D" iconName="intent" height={"20"} width={"20"} />,
                whiteImgSrc: <IconsColor fillColor={primaryColor} iconName="intent" height={"20"} width={"20"} />,
                coloredImgSrc: <IconsColor fillColor="#000000" iconName="intent" height={"20"} width={"20"} />,
            },
            {
                menuName: "Product",
                menuKey: "Product",
                navigationLink: "/product",
                flagHidden: false,
                imgSrc: <IconsColor fillColor="#4C4A4D" iconName="productPageIcon" height={"20"} width={"20"} />,
                whiteImgSrc: <IconsColor fillColor={primaryColor} iconName="productPageIcon" height={"20"} width={"20"} />,
                coloredImgSrc: <IconsColor fillColor="#000000" iconName="productPageIcon" height={"20"} width={"20"} />,
            }
        ]
    },
]
export const menuItemsMawhiba = (userDetail, apiRoutesPermissionAssignment) => {
    return [
        {
            menuName: "WhatsApp Campaign",
            menuKey: "campaign",
            navigationLink: "/whatsappcampaign",
            imgSrc: <IconsColor fillColor="#4C4A4D" iconName="campaignIcon" height={"18"} width={"18"} />,
            whiteImgSrc: <IconsColor fillColor={primaryColor} iconName="campaignIcon" height={"18"} width={"18"} />,
            coloredImgSrc: <IconsColor fillColor="#000000" iconName="campaignIcon" height={"18"} width={"18"} />,
            subMenu: [
                {
                    menuName: "Campaign",
                    menuKey: "whatsappCampaign",
                    navigationLink: "/whatsappcampaign",
                    imgSrc: <IconsColor fillColor="#4C4A4D" iconName="whatsappcampaign" height={"18"} width={"18"} />,
                    whiteImgSrc: <IconsColor fillColor={primaryColor} iconName="whatsappcampaign" height={"18"} width={"18"} />,
                    coloredImgSrc: <IconsColor fillColor="#000000" iconName="whatsappcampaign" height={"18"} width={"18"} />,
                },
                {
                    menuName: "Dashboard",
                    menuKey: "whatsappCampaignDashboard",
                    navigationLink: "/whatsappcampaign/dashboard",
                    imgSrc: <IconsColor fillColor="#4C4A4D" iconName="camapignDashboard" height={"18"} width={"18"} />,
                    whiteImgSrc: <IconsColor fillColor={primaryColor} iconName="camapignDashboard" height={"18"} width={"18"} />,
                    coloredImgSrc: <IconsColor fillColor="#000000" iconName="camapignDashboard" height={"18"} width={"18"} />,
                },
            ]
        },
        ...(hasInboxReadAccess(apiRoutesPermissionAssignment, userDetail) ? [
            {
                menuName: "Inbox",
                menuKey: "inbox",
                navigationLink: "/inbox",
                imgSrc: <IconsColor fillColor="#4C4A4D" iconName="chat" />,
                whiteImgSrc: <IconsColor fillColor={primaryColor} iconName="chat" />,
                coloredImgSrc: <IconsColor fillColor="#000000" iconName="chat" />,
            }
        ] : []),
        {
            menuName: "AI Chatbot",
            menuKey: "chatbot",
            navigationLink: "/chatbot",
            imgSrc: <IconsColor fillColor="#4C4A4D" iconName="chatbot" />,
            whiteImgSrc: <IconsColor fillColor={primaryColor} iconName="chatbot" />,
            coloredImgSrc: <IconsColor fillColor="#000000" iconName="chatbot" />,
        },
        {
            menuName: "Show More/Less",
            menuKey: "showMoreLess",
            navigationLink: "/viewMore",
            imgSrc: <MoreVertIcon sx={{ color: "#4C4A4D", height: "18px", width: "18px"}} />,
            whiteImgSrc: <MoreVertIcon sx={{ color: primaryColor, height: "18px", width: "18px"}} />,
            coloredImgSrc: <MoreVertIcon sx={{ color: "#000000", height: "18px", width: "18px"}} />,
            subMenu: [
                {
                    menuName: "Contacts",
                    menuKey: "contacts",
                    navigationLink: "/contacts",
                    imgSrc: <IconsColor fillColor="#4C4A4D" iconName="contacts" height={"18"} width={"18"} />,
                    whiteImgSrc: <IconsColor fillColor={primaryColor} iconName="contacts" height={"18"} width={"18"} />,
                    coloredImgSrc: <IconsColor fillColor="#000000" iconName="contacts" height={"18"} width={"18"} />,
                },
                {
                    menuName: "Channels",
                    menuKey: "channels",
                    navigationLink: `/channels`,
                    imgSrc: <IconsColor fillColor="#4C4A4D" iconName="integration" />,
                    whiteImgSrc: <IconsColor fillColor={primaryColor} iconName="integration" />,
                    coloredImgSrc: <IconsColor fillColor="#000000" iconName="integration" />,
                },
                {
                    menuName: "Webhook",
                    menuKey: "Webhook",
                    navigationLink: "/webhook",
                    flagHidden: false,
                    imgSrc: <IconsColor fillColor="#4C4A4D" iconName="webhookIcon" height={"20"} width={"20"} />,
                    whiteImgSrc: <IconsColor fillColor={primaryColor} iconName="webhookIcon" height={"20"} width={"20"} />,
                    coloredImgSrc: <IconsColor fillColor="#000000" iconName="webhookIcon" height={"20"} width={"20"} />,
                },
                {
                    menuName: "Custom API",
                    menuKey: "customAPI",
                    navigationLink: "/customAPI",
                    flagHidden: false,
                    imgSrc: <IconsColor fillColor="#4C4A4D" iconName="custom_api" height={"20"} width={"20"} />,
                    whiteImgSrc: <IconsColor fillColor={primaryColor} iconName="custom_api" height={"20"} width={"20"} />,
                    coloredImgSrc: <IconsColor fillColor="#000000" iconName="custom_api" height={"20"} width={"20"} />,
                }, 
                {
                    menuName: "Knowledge Base",
                    menuKey: "knowledgeBase",
                    navigationLink: "/knowledge-base",
                    flagHidden: false,
                    imgSrc: <IconsColor fillColor="#4C4A4D" iconName="knowledgeBaseIcon" height={"20"} width={"20"} />,
                    whiteImgSrc: <IconsColor fillColor={primaryColor} iconName="knowledgeBaseIcon" height={"20"} width={"20"} />,
                    coloredImgSrc: <IconsColor fillColor="#000000" iconName="knowledgeBaseIcon" height={"20"} width={"20"} />,
                },
                // {
                //     menuName: "Support Tickets",
                //     menuKey: "supportTicket",
                //     navigationLink: "/supportTicket",
                //     imgSrc: <IconsColor fillColor="#4C4A4D" iconName="feedback" />,
                //     whiteImgSrc: <IconsColor fillColor={primaryColor} iconName="feedback" />,
                //     coloredImgSrc: <IconsColor fillColor="#000000" iconName="feedback" />,
                // },
            ]
        },
    ]
}
export const menuItemsTimSafransky = [];
// export const menuItemsTimSafransky = [
//     {
//         menuName: "Call Analysis",
//         menuKey: "callanalysis",
//         navigationLink: `/callanalysis`,
//         imgSrc: <IconsColor fillColor="#4C4A4D" iconName="callAnalysis" height="16" width="16" />,
//         whiteImgSrc: <IconsColor fillColor={primaryColor} iconName="callAnalysis" height="16" width="16" />,
//         coloredImgSrc: <IconsColor fillColor="#000000" iconName="callAnalysis" height="16" width="16" />,
//     }
// ]
export const publicMenuNewItems = [
    {
        menuName: "AI Chatbot",
        menuKey: "chatbot",
        navigationLink: "/chatbot",
        imgSrc: <IconsColor fillColor="#4C4A4D" iconName="chatbot" />,
        whiteImgSrc: <IconsColor fillColor={primaryColor} iconName="chatbot" />,
        coloredImgSrc: <IconsColor fillColor="#000000" iconName="chatbot" />,
    },
    {
        menuName: "Voice Agent",
        menuKey: "voiceagent",
        navigationLink: "/voiceagent",
        imgSrc: <IconsColor fillColor="#4C4A4D" iconName="voiceAgent" width="20" height="20" />,
        whiteImgSrc: <IconsColor fillColor={primaryColor} iconName="voiceAgent" width="20" height="20" />,
        coloredImgSrc: <IconsColor fillColor="#000000" iconName="voiceAgent" width="20" height="20" />,
    },
    {
        menuName: "Inbox",
        menuKey: "inbox",
        navigationLink: "/inbox",
        imgSrc: <IconsColor fillColor="#4C4A4D" iconName="chat" />,
        whiteImgSrc: <IconsColor fillColor={primaryColor} iconName="chat" />,
        coloredImgSrc: <IconsColor fillColor="#000000" iconName="chat" />,
    },
    // {
    //     menuName: "Support Tickets",
    //     menuKey: "supportTicket",
    //     navigationLink: "/supportTicket",
    //     imgSrc: <IconsColor fillColor="#4C4A4D" iconName="feedback" />,
    //     whiteImgSrc: <IconsColor fillColor={primaryColor} iconName="feedback" />,
    //     coloredImgSrc: <IconsColor fillColor="#000000" iconName="feedback" />,
    // },
    {
        menuName: "Channels",
        menuKey: "channels",
        navigationLink: `/channels`,
        imgSrc: <IconsColor fillColor="#4C4A4D" iconName="integration" />,
        whiteImgSrc: <IconsColor fillColor={primaryColor} iconName="integration" />,
        coloredImgSrc: <IconsColor fillColor="#000000" iconName="integration" />,
    },
    // {
    //     menuName: "Dashboard",
    //     menuKey: "home",
    //     navigationLink: "/insights",
    //     imgSrc: <IconsColor fillColor="#4C4A4D" iconName="insights" height={"18"} width={"18"} />,
    //     whiteImgSrc: <IconsColor fillColor={primaryColor} iconName="insights" height={"18"} width={"18"} />,
    //     coloredImgSrc: <IconsColor fillColor="#000000" iconName="insights" height={"18"} width={"18"} />,
    // }, //this was created with static data for GITEX only
    {
        menuName: "Contacts",
        menuKey: "contacts",
        navigationLink: "/contacts",
        imgSrc: <IconsColor fillColor="#4C4A4D" iconName="contacts" height={"18"} width={"18"} />,
        whiteImgSrc: <IconsColor fillColor={primaryColor} iconName="contacts" height={"18"} width={"18"} />,
        coloredImgSrc: <IconsColor fillColor="#000000" iconName="contacts" height={"18"} width={"18"} />,
    },
    {
        menuName: "WhatsApp Campaign",
        menuKey: "campaign",
        navigationLink: "/whatsappcampaign",
        imgSrc: <IconsColor fillColor="#4C4A4D" iconName="campaignIcon" height={"18"} width={"18"} />,
        whiteImgSrc: <IconsColor fillColor={primaryColor} iconName="campaignIcon" height={"18"} width={"18"} />,
        coloredImgSrc: <IconsColor fillColor="#000000" iconName="campaignIcon" height={"18"} width={"18"} />,
        subMenu: [
            {
                menuName: "Campaign",
                menuKey: "whatsappCampaign",
                navigationLink: "/whatsappcampaign",
                imgSrc: <IconsColor fillColor="#4C4A4D" iconName="whatsappcampaign" height={"18"} width={"18"} />,
                whiteImgSrc: <IconsColor fillColor={primaryColor} iconName="whatsappcampaign" height={"18"} width={"18"} />,
                coloredImgSrc: <IconsColor fillColor="#000000" iconName="whatsappcampaign" height={"18"} width={"18"} />,
            },
            {
                menuName: "Dashboard",
                menuKey: "whatsappCampaignDashboard",
                navigationLink: "/whatsappcampaign/dashboard",
                imgSrc: <IconsColor fillColor="#4C4A4D" iconName="camapignDashboard" height={"18"} width={"18"} />,
                whiteImgSrc: <IconsColor fillColor={primaryColor} iconName="camapignDashboard" height={"18"} width={"18"} />,
                coloredImgSrc: <IconsColor fillColor="#000000" iconName="camapignDashboard" height={"18"} width={"18"} />,
            },
        ]
    },
    {
        menuName: "Rule-Based Chatbot",
        menuKey: "workFlow",
        navigationLink: "/workflow",
        imgSrc: <IconsColor fillColor="#4C4A4D" iconName="workflow" height={"20"} width={"20"} />,
        whiteImgSrc: <IconsColor fillColor={primaryColor} iconName="workflow" height={"20"} width={"20"} />,
        coloredImgSrc: <IconsColor fillColor="#000000" iconName="workflow" height={"20"} width={"20"} />,
    },
    {
        menuName: "Custom API",
        menuKey: "customAPI",
        navigationLink: "/customAPI",
        flagHidden: false,
        imgSrc: <IconsColor fillColor="#4C4A4D" iconName="custom_api" height={"20"} width={"20"} />,
        whiteImgSrc: <IconsColor fillColor={primaryColor} iconName="custom_api" height={"20"} width={"20"} />,
        coloredImgSrc: <IconsColor fillColor="#000000" iconName="custom_api" height={"20"} width={"20"} />,
    },
    {
        menuName: "Webhook",
        menuKey: "Webhook",
        navigationLink: "/webhook",
        flagHidden: false,
        imgSrc: <IconsColor fillColor="#4C4A4D" iconName="webhookIcon" height={"20"} width={"20"} />,
        whiteImgSrc: <IconsColor fillColor={primaryColor} iconName="webhookIcon" height={"20"} width={"20"} />,
        coloredImgSrc: <IconsColor fillColor="#000000" iconName="webhookIcon" height={"20"} width={"20"} />,
    }
    // The Call Analysis page is disabled as it is a client-specific custom feature.
    // {
    //     menuName: "Call Analysis",
    //     menuKey: "callanalysis",
    //     navigationLink: `/callanalysis`,
    //     imgSrc: <IconsColor fillColor="#4C4A4D" iconName="callAnalysis" height="16" width="16" />,
    //     whiteImgSrc: <IconsColor fillColor={primaryColor} iconName="callAnalysis" height="16" width="16" />,
    //     coloredImgSrc: <IconsColor fillColor="#000000" iconName="callAnalysis" height="16" width="16" />,
    //     subMenu: [
    //         {
    //             menuName: "Dashboard",
    //             menuKey: "dashboard",
    //             // navigationLink: organization_id ? `/organization?organization_id=${organization_id}` : '/organization',
    //             navigationLink: '/callanalysis',
    //             imgSrc: <IconsColor fillColor="#4C4A4D" iconName="callanalysisdashboard" height={"16"} width={"16"} />,
    //             whiteImgSrc: <IconsColor fillColor={primaryColor} iconName="callanalysisdashboard" height={"16"} width={"16"} />,
    //             coloredImgSrc: <IconsColor fillColor="#000000" iconName="callanalysisdashboard" height={"16"} width={"16"} />,
    //         },
    //         {
    //             menuName: "Call Records",
    //             menuKey: "callanalysislist",
    //             // navigationLink: organization_id ? `/organization?organization_id=${organization_id}` : '/organization',
    //             navigationLink: '/callanalysis/callrecords',
    //             imgSrc: <IconsColor fillColor="#4C4A4D" iconName="callAnalysis" height={"16"} width={"16"} />,
    //             whiteImgSrc: <IconsColor fillColor={primaryColor} iconName="callAnalysis" height={"16"} width={"16"} />,
    //             coloredImgSrc: <IconsColor fillColor="#000000" iconName="callAnalysis" height={"16"} width={"16"} />,
    //         }
    //     ]
    // }
]
export const flagUseSocketForParaphrase = true;
export const prompts = {
    AISuggestions: [
        {
            prompt_id: 1,
            prompt_name: "SEO Keyword Generation",
            prompt_key: "seo",
            template_form_field_generic_name: "blog_seo"
        },
        {
            prompt_id: 2,
            prompt_name: "Targeted Audience Generation",
            prompt_key: "target_audience",
            template_form_field_generic_name: "blog_targeted_audience"
        },
        {
            prompt_id: 3,
            prompt_name: "Tone of Voice Generation",
            prompt_key: "tone_of_voice",
            template_form_field_generic_name: "blog_tone_of_voice"
        },
        {
            prompt_id: 18,
            prompt_name: "Blog Outline Section Header",
            prompt_key: "1::blog_outline_section_header"
        },
        {
            prompt_id: 19,
            prompt_name: "Blog Outline Sub Section",
            prompt_key: "1::blog_outline_sub_section"
        },
        {
            prompt_id: 20,
            prompt_name: "Blog Editor Generation",
            prompt_key: "1::blog_editor_generation"
        },
        {
            prompt_id: 4,
            prompt_name: "Blog Title Generation",
            template_name: "Blog Post Creation",
            prompt_key: "1::blog_title",
            prompt_output_key_name: "title"
        },
        {
            prompt_id: 261,
            prompt_name: "Basic Paraphrasing",
            prompt_output_key_name: "paraphrasing"
        },

    ],
}
export const formWizPageThemeStyle = [
    {
        "page_id": "682",
        "page_theme_font_type": "Open Sans",
        "page_theme_font_style": "normal",
        "page_theme_font_align": "left",
        "page_theme_font_weight": "bold",
        "page_theme_font_size": "14",
        "page_theme_background_color": "#4C4A4D !important",
        "page_theme_heading_color": "#EFE4F1",
        "page_theme_text_decoration": "unset",
        "page_hide_button": false,
        "page_auto_save": false,
        "page_theme_row_spacing": "10px 0px 1px 0px",
        "page_theme_column_spacing": 0,
        "margin": "0px 0px 8px 0px"
    }
]

export const errorCodes = {
    "ERR_GENERAL": {
        "code": 9000,
        "message": "Something went wrong with the server.",
        "userMessage": "Something went wrong! Please try again later."
    },
    "ERR_INVALID_BODY": {
        "code": 9001,
        "message": "Invalid body!",
        "userMessage": "Something went wrong! Please try again later."
    },
    "ERR_INVALID_QUERY_PARAMETER": {
        "code": 9002,
        "message": "ERROR! Invalid query parameter.",
        "userMessage": "Something went wrong! Please try again later."
    },
    "ERR_BAD_REQUEST": {
        "code": 9003,
        "message": "ERROR! bad request found.",
        "userMessage": "Something went wrong! Please try again later."
    },
    "ERR_INVALID_RECAPTCHA": {
        "code": 9004,
        "message": "ERROR! Invalid re-Captcha found.",
        "userMessage": "ERROR! Invalid re-Captcha found."
    },
    "USER_CREATED_SUCCESSFULLY": {
        "code": 9005,
        "message": "User created successfully!",
        "userMessage": "User created successfully!"
    },
    "ERR_USER_ALREADY_EXIST": {
        "code": 9006,
        "message": "This user already exist. Please try using another email address.",
        "userMessage": "This user already exist. Please try using another email address."
    },
    "ERR_USER_NOT_VERIFIED": {
        "code": 9007,
        "message": "ERROR! User not verified.",
        "userMessage": "ERROR! User not verified."
    },
    "ERR_USER_ALREADY_ACTIVE": {
        "code": 9008,
        "message": "ERROR! This user is already active.",
        "userMessage": "ERROR! This user is already active."
    },
    "ERR_USER_NOT_FOUND": {
        "code": 9009,
        "message": "ERROR! User not found.",
        "userMessage": "ERROR! User not found."
    },
    "OTP_SENT_SUCCESSFULLY": {
        "code": 9010,
        "message": "We have successfully sent a verfication code to your email address.",
        "userMessage": "We have successfully sent a verfication code to your email address."
    },
    "USER_VERIFIED_SUCCESSFULLY": {
        "code": 9011,
        "message": "Congratulations! You've been verified successfully.",
        "userMessage": "Congratulations! You've been verified successfully."
    },
    "ERR_INVALID_OTP": {
        "code": 9012,
        "message": "ERROR! Invalid code. Please input valid code.",
        "userMessage": "ERROR! Invalid code. Please input valid code."
    },
    "ERR_INVALID_EMAIL": {
        "code": 9013,
        "message": "This user does not exist in our system. Please try using another email address.",
        "userMessage": "This user does not exist in our system. Please try using another email address."
    },
    "USER_LOGGED_IN_SUCCESSFULLY": {
        "code": 9014,
        "message": "You are Logged in Successfully!",
        "userMessage": "You are Logged in Successfully!"
    },
    "USER_LOGGED_OUT_SUCCESSFULLY": {
        "code": 9015,
        "message": "You are Logged out Successfully!",
        "userMessage": "You are Logged out Successfully!"
    },
    "ERR_PUBLIC_USER_ALREADY_EXIST": {
        "code": 9016,
        "message": "ERROR! Anonymous user already exist.",
        "userMessage": "ERROR! Anonymous user already exist."
    },
    "ERR_REQ_VALUE_NOT_FOUND": {
        "code": 9017,
        "message": "ERROR! Please provide '{{field}}' for {{prompt_name}}.",
        "userMessage": "Something went wrong! Please try again later!"
    },
    "ERR_COUNT_LIMIT_EXCEEDS": {
        "code": 9018,
        "message": "ERROR! Count limit exceeds.",
        "userMessage": "ERROR! Credit limit exceeded!"
    },
    "SOCKET_CONNECT_SUCCESSFULLY": {
        "code": 9019,
        "message": "Socket connection established successfully.",
        "userMessage": ""
    },
    "ERR_ACCESS_NOT_GRANTED": {
        "code": 9020,
        "message": "ERROR! Access not granted.",
        "userMessage": "ERROR! Access not granted."
    },
    "NO_CHANGE_FOUND": {
        "code": 9021,
        "message": "No change found!",
        "userMessage": "No change found!"
    },
    "DATA_CHANGED_SUCCESSFULLY": {
        "code": 9022,
        "message": "Data updated successfully.",
        "userMessage": "Data updated successfully."
    },
    "ERR_NO_MORE_CREDIT_LEFT": {
        "code": 9023,
        "message": "Sorry!! No more credit left.",
        "userMessage": "Sorry!! No more credit left."
    },
    "CREDITS_WITHDRAWN_SUCCESSFULLY": {
        "code": 9024,
        "message": "Credits withdrawn successfully.",
        "userMessage": "Credits withdrawn successfully."
    },
    "ERR_INVALID_PROMPT_PROPERTY": {
        "code": 9025,
        "message": "ERROR! Invalid prompt property!",
        "userMessage": "ERROR! Invalid prompt property!"
    },
    "ERR_TEMPLATE_FIELD_ID_NOT_FOUND": {
        "code": 9026,
        "message": "ERROR! Template Form Field Specified is Invalid!",
        "userMessage": "ERROR! Template Form Field Specified is Invalid!"
    },
    "DATA_CREATED_SUCCESSFULLY": {
        "code": 9027,
        "message": "Data Created Successfully!",
        "userMessage": "Data Created Successfully!"
    },
    "ERR_WHILE_EXECUTING_MSSQL_QUERY": {
        "code": 9028,
        "message": "Server error occurred while executing Database query.",
        "userMessage": "Something went wrong, Please try again later!"
    },
    "ERR_WHILE_UPLODING_FILE": {
        "code": 9029,
        "message": "Error while uploding file.",
        "userMessage": "Something went wrong, Please try again later!"
    },
    "ERR_DOWNLOAD_FILE_FROM_GOOGLE": {
        "code": 9030,
        "message": "Error occurred while downloading file.",
        "userMessage": "Error occurred while downloading file."
    },
    "ERR_DELETE_FILE_FROM_GOOGLE": {
        "code": 9031,
        "message": "Error occurred while deleting file.",
        "userMessage": "Error occurred while deleting file."
    },
    "ERR_DATA_NOT_FOUND": {
        "code": 9032,
        "message": "Data not found.",
        "userMessage": "Data not found."
    },
    "ERR_DOMAIN_NOT_FOUND": {
        "code": 9033,
        "message": "Domain not found.",
        "userMessage": "Domain not found."
    },
    "ERR_INVALID_DOMAIN_NAME": {
        "code": 9034,
        "message": "Invalid domain name.",
        "userMessage": "Invalid domain name."
    },
    "ERR_ORGANIZATION_NOT_FOUND": {
        "code": 9035,
        "message": "ERROR! Organization not found.",
        "userMessage": "ERROR! Organization not found."
    },
    "ERR_USER_ALREADY_EXIST_IN_ORGANIZATION": {
        "code": 9036,
        "message": "ERROR! User is already associate with another organization.",
        "userMessage": "ERROR! User is already associate with another organization."
    },
    "ERR_EMAIL_ADDRESS_NOT_FOUND": {
        "code": 9037,
        "message": "Please provide your email address.",
        "userMessage": "Please provide your email address."
    },
    "ERR_USERNAME_NOT_FOUND": {
        "code": 9038,
        "message": "Please provide your name.",
        "userMessage": "Please provide your name."
    },
    "ERR_MESSAGE_NOT_FOUND": {
        "code": 9039,
        "message": "Please provide appropriate message.",
        "userMessage": "Please provide appropriate message."
    },
    "MESSAGE_RECIEVED_SUCCESSFULLY": {
        "code": 9040,
        "message": "Your message has been received successfully, and we will be in touch with you shortly.",
        "userMessage": "Your message has been received successfully, and we will be in touch with you shortly."
    },
    "ERR_AI_MODULE": {
        "code": 9041,
        "message": "ERROR! creating persona. Please try again after sometime.",
        "userMessage": "Something went wrong! Please try again later."
    },
    "ERR_NO_ORGANIZATION_FOUND": {
        "code": 9042,
        "message": "ERROR! No organization found for this user.",
        "userMessage": "ERROR! No organization found for this user."
    },
    "TEMPLATE_DELETED_SUCCESSFULLY": {
        "code": 9043,
        "message": "Template deleted successfully.",
        "userMessage": "Template deleted successfully."
    },
    "ERR_EMAIL_ADDRESS_BLACKLIST": {
        "code": 9044,
        "message": "ERROR! Please provide a valid email address.",
        "userMessage": "ERROR! Please provide a valid email address."
    },
    "ERR_HEAVY_LOAD_TO_SERVER": {
        "code": 9045,
        "message": "Please try again later. Our system is currently experiencing a high server load.",
        "userMessage": "Please try again later. Our system is currently experiencing a high server load."
    },
    "ERR_INVALID_TOKEN": {
        "code": 9046,
        "message": "Token expired or invalid. Please try again later.",
        "userMessage": "Something went wrong! Please try again later."
    },
    "ERR_INVALID_ORGANIZATION": {
        "code": 9047,
        "message": "Invalid organization found.",
        "userMessage": "Invalid organization found."
    },
    "DOCUMENT_DELETED_SUCCESSFULLY": {
        "code": 9048,
        "message": "Document deleted successfully.",
        "userMessage": "Document deleted successfully."
    },
    "ERR_PERSONA_DELETED_SUCCESSFULLY": {
        "code": 9049,
        "message": "Persona deleted successfully.",
        "userMessage": "Persona deleted successfully."
    },
    "DATA_SAVED_SUCCESSFULLY": {
        "code": 9050,
        "message": "Data Saved Successfully!",
        "userMessage": "Data Saved Successfully!"
    },
    "ERR_AI_EXECUTION": {
        "code": 9051,
        "message": "Sorry, we encountered an unexpected issue processing your input. Please try again later.",
        "userMessage": "Sorry, we encountered an unexpected issue processing your input. Please try again later."
    },
    "ERR_CANNOT_DELETE": {
        "code": 9052,
        "message": "Cannot delete all documents.",
        "userMessage": "Sorry, we encountered an unexpected issue processing your input. Please try again later."
    },
    "ERR_INVALID_FILE_TYPE": {
        "code": 9053,
        "message": "Invalid file type.",
        "userMessage": "Invalid file type."
    },
    "ERR_INVALID_AUTHENTICATION_FOUND": {
        "code": 9054,
        "message": "Invalid authentication found.",
        "userMessage": "Invalid authentication found."
    },
    "CAMPAIGN_DELETED_SUCCESSFULLY": {
        "code": 9056,
        "message": "Campaign deleted successfully.",
        "userMessage": "Campaign deleted successfully."
    },
    "ERR_SOMTHING_WANT_WRONG": {
        "code": 9057,
        "message": "Something went wrong.",
        "userMessage": "Something went wrong."
    },
    "CAMPAIGN_DOCUMNET_BEING_CREATED": {
        "code": 9058,
        "message": "Campaign documents are currently being generated. Please wait for their completion.",
        "userMessage": "Campaign documents are currently being generated. Please wait for their completion."
    },
    "CAMPAIGN_LIMIT_REACHED": {
        "code": 9271,
        "message": "Your WhatsApp campaign messaging limit has been reached. Please contact support to continue sending messages.",
        "userMessage": "Your WhatsApp campaign messaging limit has been reached. Please contact support to continue sending messages."
    },
    "DEFAULT_PERSONA_REMOVED": {
        "code": 9059,
        "message": "Persona removed from default successfully.",
        "userMessage": "Persona removed from default successfully."
    },
    "ERR_DIRECTORY_FOUND": {
        "code": 9060,
        "message": "ERROR! It looks like the directory you're trying to access doesn't exist or may have been removed.",
        "userMessage": "ERROR! It looks like the directory you're trying to access doesn't exist or may have been removed."
    },
    "ERR_CHAT_THREAD_NOT_FOUND": {
        "code": 9061,
        "message": "ERROR! It looks like the chat thread you're trying to access doesn't exist or may have been removed.",
        "userMessage": "ERROR! It looks like the chat thread you're trying to access doesn't exist or may have been removed."
    },
    "ERR_USER_CHAT_LIMIT_EXCEED": {
        "code": 9062,
        "message": "Chat Limit Reached: Please start a new conversation thread with Chat, as this one has reached the limit and won't retain past context.",
        "userMessage": "Chat Limit Reached: Please start a new conversation thread with Chat, as this one has reached the limit and won't retain past context."
    },
    "ERR_STREAM_NOT_SUPPORTED": {
        "code": 9063,
        "message": "Sorry! Stream is not supported.",
        "userMessage": "Something went wrong, Please try again later!"
    },
    "DATA_DELETED_SUCCESSFULLY": {
        "code": 9064,
        "message": "{{deleted_data_name}} deleted successfully.",
        "userMessage": "Something went wrong, Please try again later!"
    },
    "ERR_CANNOT_DELETE_PROMPT": {
        "code": 9065,
        "message": "Before deleting prompt, first delete all prompt variant & prompt property.",
        "userMessage": "Something went wrong, Please try again later!"
    },
    "ERR_PROMPT_PROPERTY_ALREADY_EXISTS": {
        "code": 9066,
        "message": "ERROR! prompt property that you are trying to add that already exists.",
        "userMessage": "Something went wrong, Please try again later!"
    },
    "ERR_CANNOT_DELTE_PROMPT_PROPERTY": {
        "code": 9067,
        "message": "ERROR! Before deleting prompt property remove property from each variant",
        "userMessage": "Something went wrong, Please try again later!"
    },
    "ERR_INVALID_MODEL": {
        "code": 9068,
        "message": "ERROR! Invalid Model.",
        "userMessage": "Something went wrong, Please try again later!"
    },
    "ERR_PROMPT_LOG_FIELD_ALREADY_EXISTS": {
        "code": 9069,
        "message": "ERROR! prompt log field that you are trying to add that already exists.",
        "userMessage": "Something went wrong, Please try again later!"
    },
    "ERR_INVALID_PROMPT_LOG_FIELD": {
        "code": 9070,
        "message": "Invalid prompt log field found.",
        "userMessage": "Something went wrong, Please try again later!"
    },
    "ERR_USER_HEAVY_LOAD_TO_SERVER": {
        "code": 9071,
        "message": "Sorry, you've reached your daily usage limit.",
        "userMessage": "Sorry, you've reached your daily usage limit."
    },
    "ERR_FILE_SIZE_EXCEED": {
        "code": 9072,
        "message": "ERROR! Your file size is too large to upload.",
        "userMessage": "ERROR! Your file size is too large to upload."
    },
    "ERR_UPLOADING_FILE": {
        "code": 9073,
        "message": "Error occurred while uploading file.",
        "userMessage": "Error occurred while uploading file."
    },
    "ERR_INVALID_JSON_FOUND": {
        "code": 9074,
        "message": "ERROR! Invalid JSON Found.",
        "userMessage": "Something went wrong! Please try again later."
    },
    "ERR_ALREADY_INTEGRATED": {
        "code": 9075,
        "message": "ERROR! Your account is already integrated.",
        "userMessage": "ERROR! Your account is already integrated."
    },
    "ERR_PHONE_NUMBER_NOT_FOUND": {
        code: 9076,
        message: "ERROR! Please add atleast one phone number to your WhatsApp Business Account to continue integration.",
        userMessage: "ERROR! Please add atleast one phone number to your WhatsApp Business Account to continue integration."
    },
    "ERR_PHONE_NUMBER_ALREADY_INTEGRATED": {
        code: 9077,
        message: "ERROR! This phone number is already integrated to one of the chatbot.",
        userMessage: "ERROR! This phone number is already integrated to one of the chatbot."
    },
    "ERR_TRAVEL_AGENT_ALREADY_EXIST": {
        code: 9078,
        message: "ERROR! This travel agent already exist in our system.",
        userMessage: "Something went wrong! Please try again later."
    },
    "ERR_USER_PHONE_NUMBER_ALREADY_EXIST": {
        code: 9079,
        message: "Error! The phone number linked to another Agent already exists in our system.",
        userMessage: "Error! The phone number linked to another Agent already exists in our system."
    },

    ERR_INVALID_USER_CHATBOT_ACCESS: {
        code: 9080,
        message: "Hello {{username}}, your access to this service is currently restricted. Please reach out to your service provider to continue using this service.",
        userMessage: "Hello, your access to this service is currently restricted. Please reach out to your service provider to continue using this service."
    },
    ERR_CHATBOT_SERVICE_PAUSED: {
        code: 9081,
        message: "Hello {{username}}, this service has been deactivated and is currently unavailable. For further assistance, please reach out to the service provider.",
        userMessage: "Hello, this service has been deactivated and is currently unavailable. For further assistance, please reach out to the service provider."
    },
    ERR_CHATBOT_SERVICE_EXPIRED: {
        code: 9082,
        message: "Hello {{username}}, this service is currently unavailable as it has expired. Please reach out to the service provider for further assistance."
    },
    ERR_TEMPLATE_ALREADY_EXIST: {
        code: 9083,
        message: "ERROR! Template Name Already Exist",
        userMessage: "ERROR! Template Name Already Exist"
    },
    ERR_INVALID_FUNCTION_METHOD: {
        code: 9084,
        message: "ERROR! Invalid Method found.",
        userMessage: "ERROR! Invalid Method found.",
    },
    ERR_FUNCTION_URL_NOT_FOUND: {
        code: 9085,
        message: "ERROR! Invalid URL found.",
        userMessage: "ERROR! Invalid URL found.",
    },
    ERR_DATA_CONNECTOR_FOUND_INVALID: {
        code: 9086,
        message: "ERROR! Invalid data connector found.",
        userMessage: "ERROR! Invalid data connector found.",
    },
    ERR_DC_FUNCTION_NAME_NF: {
        code: 9087,
        message: "ERROR! Data connector function name not found.",
        userMessage: "ERROR! Data connector function name not found."
    },
    ERR_DC_FUNCTION_DESC_NF: {
        code: 9088,
        message: "ERROR! Data connector function description not found.",
        userMessage: "ERROR! Data connector function description not found."
    },
    ERR_DATA_CONNECTOR_FUNCTION_FOUND_INVALID: {
        code: 9089,
        message: "ERROR! Invalid data connector function found.",
        userMessage: "ERROR! Invalid data connector function found."
    },
    ERR_HEADER_KEY_NOT_FOUND: {
        code: 9090,
        message: "Header key is missing.",
        userMessage: "Header key is missing."
    },
    ERR_HEADER_KEY_VALUE_NOT_FOUND: {
        code: 9091,
        message: "Value for the given header key is missing.",
        userMessage: "Value for the given header key is missing."
    },
    ERR_HEADER_FOUND_INVALID: {
        code: 9092,
        message: "ERROR! Invalid header.",
        userMessage: "ERROR! Invalid header."
    },
    ERR_HEADER_KEY_ALREADY_EXIST: {
        code: 9093,
        message: "The provided Header Key already exists. Please provide a unique one.",
        userMessage: "The provided Header Key already exists. Please provide a unique one."
    },
    ERR_URL_METHOD_ALREADY_EXIST: {
        code: 9094,
        message: "The provided URL '{{url}}' with method '{{method_name}}' already exists.",
        userMessage: "The provided URL already exists."
    },
    ERR_DATA_CONNECTOR_FUNCTION_NAME_ALREADY_EXIST: {
        code: 9095,
        message: "The provided function '{{function_name}}' already exists.",
        userMessage: "The provided function already exists."
    },
    ERR_FUNCTION_RESPONSE_FOUND_EMPTY: {
        code: 9096,
        message: "The provided response of the function founds to be empty.",
        userMessage: "The provided response of the function founds to be empty."
    },
    ERR_FUNCTION_PARAMS_INVALID: {
        code: 9097,
        message: "ERROR! Invalid parameter.",
        userMessage: "Something went wrong! Please try again later!"
    },
    ERR_FUNCTION_PARAMETER_FOUND_EMPTY: {
        code: 9098,
        message: "The provided parameter of the function founds to be empty.",
        userMessage: "The provided parameter of the function founds to be empty."
    },
    ERR_PARAMS_ALREADY_EXIST: {
        code: 9099,
        message: "The provided parameter in function {{function_name}} already exist.",
        userMessage: "The provided parameter in function already exist."
    },
    ERR_PARAMS_NAME_NOT_FOUND: {
        code: 9100,
        message: "Parameter name not found in function {{function_name}}.",
        userMessage: "Parameter name not found in function"
    },
    ERR_PARAMS_DESC_NOT_FOUND: {
        code: 9101,
        message: "Parameter description not found in function {{function_name}}.",
        userMessage: "Parameter description not found in function"
    },
    ERR_PARAMS_TYPE_INVALID: {
        code: 9102,
        message: "The provided parameter type found to be invalid.",
        userMessage: "The provided parameter type found to be invalid."
    },
    ERR_FUNCTION_RESPONSE_INVALID: {
        code: 9103,
        message: "ERROR! Invalid response.",
        userMessage: "ERROR! Invalid response."
    },
    ERR_RES_NAME_NOT_FOUND: {
        code: 9104,
        message: "Response name not found in function {{function_name}}.",
        userMessage: "Response name not found in function"
    },
    ERR_RES_DESC_NOT_FOUND: {
        code: 9105,
        message: "Response description not found in function {{function_name}}.",
        userMessage: "Response description not found in function!"
    },
    ERR_RES_ALREADY_EXIST: {
        code: 9106,
        message: "The provided response in function {{function_name}} already exist.",
        userMessage: "The provided response already exist."
    },
    ERR_NOTES_CATEGORY_ALREADY_EXIST: {
        code: 9107,
        message: "ERROR! Notes Category Already Exist",
        userMessage: "ERROR! Notes Category Already Exist"
    },
    ERR_CHABOT_SUBSCRIPTION_ALREADY_EXIST: {
        code: 9108,
        message: "ERROR! The User Has Already Subscribed To The Chatbot",
        userMessage: "ERROR! The User Has Already Subscribed To The Chatbot"
    },
    CHATBOT_SUBSCRIPTION_STARTED_SUCCESSFULLY: {
        code: 9109,
        message: `Chatbot {{plan_name}} Plan Subscription Started Successfully!`,
        userMessage: "Chatbot Plan Subscription Started Successfully!"
    },
    ERR_NO_INTEGRATION_FOUND: {
        code: 9110,
        message: "ERROR! No Integration found with this chatbot.",
        userMessage: "ERROR! No Integration found with this chatbot."
    },
    WA_TEMPLATE_CREATED: {
        code: 9111,
        message: "WhatsApp template created successfully.",
        userMessage: "WhatsApp template created successfully."
    },
    ERR_INVALID_PARAMS: {
        code: 9112,
        message: "ERROR! Invalid params.",
        userMessage: "Something went wrong. Please try again later!"
    },
    ERR_PAGE_ALREADY_INTEGRATED: {
        code: 9113,
        message: "The Facebook page you are attempting to integrate is already connected to our system.",
        userMessage: "The Facebook page you are attempting to integrate is already connected to our system."
    },
    ERR_CHATBOT_SYSTEM_VARIABLE_ALREADY_EXISTS: {
        code: 9114,
        message: "ERROR! Chatbot system variable already exist.",
        userMessage: "ERROR! Chatbot system variable already exist."
    },
    USER_INVITED_ORG_SUCCESSFULLY: {
        code: 9115,
        message: "User invited to organization successfully.",
        userMessage: "User invited to organization successfully."
    },
    ERR_TOKEN_INVALID_EXPIRE: {
        code: 9116,
        message: "ERROR! Invitation token is invalid or expired.",
        userMessage: "ERROR! Invitation token is invalid or expired."
    },
    USER_REMOVED_SUCCESSFULLY: {
        code: 9117,
        message: "User removed successfully.",
        userMessage: "User removed successfully."
    },
    ERR_USER_ALREADY_IN_ORG: {
        code: 9118,
        message: "ERROR! User already exists in the organization.",
        userMessage: "ERROR! User already exists in the organization."
    },
    DELEGATE_ACCESS_GRANTED: {
        code: 9119,
        message: "Delegate access granted successfully.",
        userMessage: "Delegate access granted successfully."
    },
    DELEGATE_ACCESS_REVOKED: {
        code: 9120,
        message: "Delegate access revoked successfully.",
        userMessage: "Delegate access revoked successfully."
    },
    ERR_DELEGATE_ACCESS_ALREADY_GRANTED: {
        code: 9121,
        message: "ERROR! Delegate access is already granted.",
        userMessage: "ERROR! Delegate access is already granted."
    },
    ERR_DELEGATE_ACCESS_ALREADY_REVOKED: {
        code: 9122,
        message: "ERROR! Delegate access is already revoked.",
        userMessage: "ERROR! Delegate access is already revoked."
    },
    ERR_DELEGATE_ACCESS_INVALID: {
        code: 9123,
        message: "ERROR! Invalid user, delegate access can not be granted.",
        userMessage: "ERROR! Invalid user, delegate access can not be granted."
    },
    CALENDLY_INTEGRATED_SUCCESSSFULLY: {
        code: 9124,
        message: "Calendly integrated successfully.",
        userMessage: "Calendly integrated successfully."
    },
    ERR_PERSISTENT_MENU_ALREADY_EXISTS: {
        code: 9125,
        message: "ERROR! Persistent menu already exist.",
        userMessage: "ERROR! Persistent menu already exist."
    },
    ERR_DC_FUNCTION_RESPONSE: {
        code: 9126,
        message: "Invalid response. Reason: {{reason}}.",
        userMessage: "Something went wrong! Please try again later!"
    },
    ERR_DC_FUNCTION_PARAMS: {
        code: 9127,
        message: "Invalid parameters. Reason: {{reason}}.",
        userMessage: "Something went wrong! Please try again later!"
    },
    ACUITY_INTEGRATED_SUCCESSSFULLY: {
        code: 9128,
        message: "Acuity integrated successfully.",
        userMessage: "Acuity integrated successfully."
    },
    ERR_INVALID_INTEGRATION_TYPE: {
        code: 9129,
        message: "ERROR! Invalid integration type.",
        userMessage: "Something went wrong! Please try again later."
    },
    SLACK_INTEGRATED_SUCCESSSFULLY: {
        code: 9130,
        message: "Slack integrated successfully",
        userMessage: "Slack integrated successfully",
    },
    ERR_FUNCTION_PATH_NOT_FOUND: {
        code: 9131,
        message: "ERROR! Invalid Function Path.",
        userMessage: "Something went wrong! Please try again later.",
    },
    CHATBOT_SLACK_ASSIGNMNET_DELETED_SUCCESSSFULLY: {
        code: 9132,
        message: "Chatbot slack assignment deleted successfully",
        userMessage: "Chatbot slack assignment deleted successfully",
    },
    SLACK_INTEGRATION_DELETED_SUCCESSSFULLY: {
        code: 9133,
        message: "Slack integration deleted successfully",
        userMessage: "Slack integration deleted successfully",
    },
    ERR_CHAT_CLOSED: {
        code: 9134,
        message: "Chat is closed.",
        userMessage: "Chat is closed."
    },
    ERR_CHAT_ALREADY_PROCESSING: {
        code: 9135,
        message: "Your thread is already active. Please wait for the response.",
        userMessage: "Your thread is already active. Please wait for the response."
    },
    THREAD_SWITCHED_SUCCESSFULLY: {
        code: 9136,
        message: "Thread Switched Successfully.",
        userMessage: "Thread Switched Successfully."
    },
    ERROR_NOT_MANUAL_OVERRIDE: {
        code: 9137,
        message: "ERROR! You are currently not in manual override mode. Please switch to manual mode",
        userMessage: "ERROR! You are currently not in manual override mode. Please switch to manual mode"
    },
    CART_EMPTY: {
        code: 9138,
        message: "Cart has been successfully emptied.",
        userMessage: "Cart has been successfully emptied."
    },
    ERR_CAMPAIGN_RUNNING: {
        code: 9139,
        message: "The campaign is in progress, Please await their completion.",
        userMessage: "The campaign is in progress, Please await their completion."
    },
    ZOHO_INTEGRATED_SUCCESSSFULLY: {
        code: 9140,
        message: "Zoho integrated successfully",
        userMessage: "Zoho integrated successfully"
    },
    ZOHO_INTEGRATION_DELETED_SUCCESSSFULLY: {
        code: 9141,
        message: "Zoho integration deleted successfully",
        userMessage: "Zoho integration deleted successfully"
    },
    ERR_INSTAGRAM_ALREADY_INTEGRATED: {
        code: 9142,
        message: "The instagram account you are attempting to integrate is already connected to our system.",
        userMessage: "The instagram account you are attempting to integrate is already connected to our system."
    },
    ERR_THREAD_NOT_FOUND: {
        code: 9143,
        message: "ERROR! Invalid Thread ID",
        userMessage: "Something went wrong! Please try again later."
    },
    ERR_INVALID_AGENT_ID:
    {
        code: 9144,
        message: "Invalid agent id or Access not granted to agent",
        userMessage: "Invalid agent id or Access not granted to agent"
    },
    ERR_WA_THREAD_META_DATA_NOT_FOUND: {
        code: 9145,
        message: "WA thread meta data not found",
        userMessage: "WA thread meta data not found"
    },
    ERR_NO_ACTIVE_AGENT: {
        code: 9146,
        message: "No active agent found",
        userMessage: "No active agent found"
    },
    ERR_WHATSAPP_TEMPLATE_NOT_APPROVED: {
        code: 9147,
        message: "ERROR! The WhatsApp template is not available for use.",
        userMessage: "ERROR! The WhatsApp template is not available for use."
    },
    ERR_INVALID_CHATBOT_STEP: {
        code: 9148,
        message: "ERROR! Invalid chatbot step.",
        userMessage: "ERROR! Invalid chatbot step."
    },
    ERR_INVALID_WF_CONFIGURATION: {
        code: 9149,
        message: "ERROR! Invalid Configuration.",
        userMessage: "ERROR! Invalid Configuration."
    },
    ERR_VARIABLE_ALREADY_EXIST: {
        code: 9150,
        message: "ERROR! Variable with same name already exist",
        userMessage: "ERROR! Variable with same name already exist",
    },
    ERR_THREAD_NOT_JOINED: {
        code: 9151,
        message: "ERROR! Thread not joined",
        userMessage: "ERROR! Thread not joined"
    },
    ERR_INVALID_ACTIVITY_TYPE: {
        code: 9152,
        message: "ERROR! Invalid activity type found.",
        userMessage: "ERROR! Invalid activity type found.",
    },
    ERR_CB_FIELD_ID_REQUIRED: {
        code: 9153,
        message: "ERROR! Chatbot {{field}} ID is required parameter.",
        userMessage: "Something went wrong! Please try again later!"
    },
    ERR_INVALID_CB_STEP_COORDINATES: {
        code: 9154,
        message: "ERROR! Please provide valid step coordinates.",
        userMessage: "ERROR! Please provide valid step coordinates."
    },
    ERR_INVALID_CB_STEP: {
        code: 9155,
        message: "ERROR! Invalid chatbot step",
        userMessage: "ERROR! Invalid chatbot step"
    },
    ERR_INVALID_CB_STEP_FLOW_CONDITION: {
        code: 9156,
        message: "ERROR! Invalid condition found in step flow.",
        userMessage: "ERROR! Invalid condition found in step flow."
    },
    ERR_INVALID_PARENT_CB_STEP_FLOW: {
        code: 9157,
        message: "ERROR! Invalid parent step flow",
        userMessage: "ERROR! Invalid parent step flow"
    },
    ERR_INVALID_CB_ACTION_TYPE: {
        code: 9158,
        message: "ERROR! Invalid action type.",
        userMessage: "ERROR! Invalid action type."
    },
    ERR_INVALID_CB_ACTION_DATA: {
        code: 9159,
        message: "ERROR! Invalid action data.",
        userMessage: "ERROR! Invalid action data."
    },
    ERR_INVALID_CB_ACTION_VALUE_TYPE: {
        code: 9160,
        message: "ERROR! Invalid action value type in save variable action data",
        userMessage: "ERROR! Invalid action value type in save variable action data"
    },
    ERR_INVALID_CB_ACTION_VARIABLE_TYPE: {
        code: 9161,
        message: "ERROR! Invalid action variable type.",
        userMessage: "ERROR! Invalid action variable type."
    },
    ERR_INVALID_WA_TEMPLATE_DYNAMIC_VARIABLE: {
        code: 9162,
        message: "ERROR! Invalid WhatsApp Template Dynamic Variable.",
        userMessage: "ERROR! Invalid WhatsApp Template Dynamic Variable."
    },
    ERR_INVALID_CB_STEP_FLAG_COUNT: {
        code: 9163,
        message: "ERROR! Chatbot must have exactly one start node. Found 0.",
        userMessage: "ERROR! Chatbot must have exactly one start node. Found 0."
    },
    ERR_CANNOT_DELETE_CHATBOT: {
        code: 9164,
        message: "ERROR! Cannot delete this chatbot as it has active sub-chatbots. Please delete the sub-chatbots first.",
        userMessage: "ERROR! Cannot delete this chatbot as it has active sub-chatbots. Please delete the sub-chatbots first."
    },
    CHATBOT_MAPPING_DELETED_SUCCESSSFULLY: {
        code: 9165,
        message: "Chatbot mapping deleted successfully.",
        userMessage: "Chatbot mapping deleted successfully."
    },
    ERROR_PARENT_CANNOT_BE_CHILD: {
        code: 9166,
        message: "A parent chatbot cannot be set as a child of another chatbot.",
        userMessage: "A parent chatbot cannot be set as a child of another chatbot."
    },
    ERROR_LINK_BUSINESS_ACCOUNT: {
        code: 9167,
        message: "ERROR! You need to link your WA business account before using WA templates.",
        userMessage: "ERROR! You need to link your WA business account before using WA templates."
    },
    ERR_INSTAGRAM_ALREADY_INTEGRATED_WITH_FACEBOOK: {
        code: 9168,
        message: "The instagram account you are attempting to integrate is already integrated using facebook to our system.",
        userMessage: ""
    },
    INSTAGRAM_INTEGRATED_SUCCESSSFULLY: {
        code: 9169,
        message: "Instagram integrated successfully",
        userMessage: "Instagram integrated successfully"
    },
    IG_TEMPLATE_DATA_NOT_VALID: {
        code: 9170,
        message: "Instagram template data is not valid",
        userMessage: "Instagram template data is not valid"
    },
    IG_MEDIA_CONTENT_NOT_KNOWN: {
        code: 9171,
        message: "instagram content not know",
        userMessage: "instagram content not know"
    },
    WA_BUSINESS_ACCOUNT_ALREADY_ADDED: {
        code: 9172,
        message: "ERROR! Whatsapp business account already added.",
        userMessage: "ERROR! Whatsapp business account already added."
    },
    INTEGRATED_CHANNEL_ALREADY_ADDED: {
        code: 9173,
        message: "ERROR! Integrated channel already added.",
        userMessage: "ERROR! Integrated channel already added."
    },
    ERR_CHATBOT_ALREADY_PUBLISHED: {
        code: 9174,
        message: "Chatbot is already published.",
        userMessage: "Chatbot is already published."
    },
    ERR_NO_CHATBOT_DEPLOYED: {
        code: 9235,
        message: "No chatbot deployed.",
        userMessage: "No chatbot deployed."
    }, 
    ERR_CHATBOT_ALREADY_CLOSED: {
        code: 9236, 
        message: "Chatbot is already closed.", 
        userMessage: "Chatbot is already closed."
    },
    ERR_WA_TEMPLATE_NOT_MATCHED: {
        code: 9175,
        message: "WA Template - {{template_name}}, Invalid Template {{error}}.",
        userMessage: ""
    },
    ERR_INVALID_VARIABLE_NAME:
    {
        code: 9151,
        message: "ERROR! Variable with same name already exist",
        userMessage: "Field Name Already Exist."
    },
    "INVALID_JSON_FROM_BE": {
        "code": 1110,
        "message": "Oops! Something went wrong! Please try again later.",
        "userMessage": "Oops! Something went wrong! Please try again later."
    },
    ERR_INVALID_CONTACT_IMPORT_LOG_MAPPING: {
        code: 9196,
        message: "Invalid contact import log mapping!",
        userMessage: "Please map all required columns (First Name, Phone Number and Country Code) before importing."
    },
    Nothing_MATCHED: {
        code: 1111,
        message: "No code matched!!",
        userMessage: "Something went wrong! Please try again later."
    },

}

export const CHRONOX_ROLES = {
    DEVELOPER_ROLE: "Developer",
    SUPER_ADMIN_ROLE: "Super Admin",
    ADMIN_ROLE: "Admin"
}

export const ORGANIZATION_ROLES = {
    OWNER_ROLE: "Organization Owner",
    ADMIN_ROLE: "Organization Admin",
    MEMBER_ROLE: "Organization Member",
    AGENT_ROLE: "Organization Agent"
}

export const USER_ASSIGNMENT_ROLES = {
    AGENT_ROLE: "Agent",
    AGENT_ADMIN_ROLE: "Agent Admin",
    ADMIN_ROLE: "Admin",
    DEVELOPER_ROLE: "Developer",
    OWNER_ROLE: "Owner",
    SUPER_OWNER_ROLE: "Super owner"
}

export const getEffectiveUserRoleName = (userDetail) => {
  return userDetail?.user_assignment_role_data?.length > 0
    ? userDetail?.user_assignment_role_data?.[0]?.chronox_user_role_name?.toLowerCase()
    : userDetail?.user_organization_data?.user_organization_role_name?.toLowerCase();
};

export const getEffectiveAdminRoleName = (userDetail) => {
  return userDetail?.user_assignment_role_data?.length
    ? USER_ASSIGNMENT_ROLES["ADMIN_ROLE"]?.toLowerCase()
    : ORGANIZATION_ROLES["ADMIN_ROLE"]?.toLowerCase();
}

export function isDev(userDetail) {
    if (userDetail && userDetail.user_role) {
        return (userDetail.user_role.user_role_name?.toLowerCase() === CHRONOX_ROLES["DEVELOPER_ROLE"]?.toLowerCase() || userDetail.user_role.user_role_name?.toLowerCase() === CHRONOX_ROLES["SUPER_ADMIN_ROLE"]?.toLowerCase() || userDetail.user_role.user_role_name?.toLowerCase() === CHRONOX_ROLES["ADMIN_ROLE"]?.toLowerCase());
    }
    return false;
}
export function isDelegateAccessUserAdmin(userDetail) {
    if (userDetail?.user_delegate_access_flag && isAdmin(userDetail?.user_delegate_access_data)) {
        return true
    }
    return false
}
export function isAdmin(userDetail) {
    if (isDelegateAccessUserAdmin(userDetail)) {
        return true
    } else if (userDetail && userDetail.user_role) {
        return (userDetail.user_role.user_role_name?.toLowerCase() === CHRONOX_ROLES["SUPER_ADMIN_ROLE"]?.toLowerCase() || userDetail.user_role.user_role_name?.toLowerCase() === CHRONOX_ROLES["ADMIN_ROLE"]?.toLowerCase());
    } else if(userDetail && userDetail?.user_assignment_role_data?.length > 0){
        const userAssignmentRoleName = userDetail?.user_assignment_role_data?.[0]?.chronox_user_role_name?.toLowerCase();
        return (userAssignmentRoleName == USER_ASSIGNMENT_ROLES["DEVELOPER_ROLE"]?.toLowerCase() || userAssignmentRoleName == USER_ASSIGNMENT_ROLES["SUPER_OWNER_ROLE"]?.toLowerCase());
    }
    return false;
}

export function getStripeProduct(userDetail) {
    if (userDetail?.plan_detail?.credit_usage_data?.stripe_product_name === "Premium" && userDetail?.plan_detail?.credit_usage_data?.stripe_customer_subscription_interval === "10 days") {
        return "Free Premium"
    }
    else if (userDetail?.plan_detail?.credit_usage_data?.stripe_product_name === "Free") {
        return "Free"
    }
    else if (userDetail?.plan_detail?.credit_usage_data?.stripe_product_name === "Premium") {
        return "Premium"
    }
    else {
        return "Anonymous"
    }
}
export function getErrorMessage(code, flagDeveloper, response) {
    for (const key in errorCodes) {
        if (errorCodes[key].code === code) {
            const errorCode = errorCodes[key];
            return flagDeveloper
                ? errorCode.message : errorCode.userMessage
        }
    }
     
    const errorMsg = typeof response?.error === "string" ? response.error : "";
    
    // If code is not found, default to Nothing_MATCHED
    const nothingMatched = errorCodes.Nothing_MATCHED;
    return errorMsg ? errorMsg : flagDeveloper ? nothingMatched.message : nothingMatched.userMessage;
}
export function flagCreditsExhausted(errorCode) {
    return (errorCode === 9023 || errorCode === 9071) ? true : false
}
export function flagCookieExpired(userDetail, errorCode) {
    if (userDetail.flagUser) {
        if (errorCode === -999) {
            return true
        } else {
            return false
        }
    } else {
        return false
    }
}
export function checkForErrorCode(response) {
    let errorCode = response?.isAxiosError ? (response?.response && response?.response?.data ? (response?.response?.data?.error?.code || response?.response?.data?.error?.statusCode || response?.data?.error?.code || response?.data?.error?.statusCode || response) : response) : (response?.error?.code || response?.error?.statusCode);
    return errorCode;
}
export function ifUserMessageShouldBeDynamic(errorCode) {
    let dynamicErrorCode = [9017, 9064, 9080, 9081, 9082, 9094, 9095, 9099, 9100, 9101, 9104, 9105, 9106, 9109, 9126, 9127, 9153, 9175, 100, 9244, 9245, 9247, 100, 9248, 401, 9232, 9312, 9313, 9401, 9270, 9437, 9436, 9055, 9320, 9321, 9322, 9323, 9324, 9325, 9328, 9329, 9448, 9449, 9445, 9450, 9333, 9308, 9309, 9310, 9311, 9314, 9315, 9316, 9318, 9330, 9331, 9332, 9199]
    if (dynamicErrorCode.includes(errorCode)) {
        return true
    } else {
        return false
    }
}
export function invalidQueryParameter(response) {
    let errorCode = response.isAxiosError ? (response.response && response.response.data ? (response?.response?.data?.error?.code || response?.data?.error?.code || response) : response) : response?.error?.code;
    if (errorCode == 9002 || errorCode == 9032) {
        return true
    }
}

export function getChatbotMessageTag(chatbotThread, textType) {
    switch (textType) {
        case "text":
            return chatbotThread.chatbot_thread_value
        case "image":
            return <img className={globalStyles.clickable}
                src={chatbotThread?.chatbot_thread_value} alt="img" style={{}} />
        case "contact":
            return <ContactCard contactInfo={chatbotThread.contact_information} />
        case "location":
            return <div style={{ display: "flex", flexDirection: "column" }}><iframe src={chatbotThread?.chatbot_thread_value} title="location" style={{ border: 0 }} allowFullScreen loading="lazy" ></iframe><span><a rel="noreferrer" target='blank' href={chatbotThread?.chatbot_thread_value}>{chatbotThread?.chatbot_thread_value}</a></span></div>
        default:
            return chatbotThread.chatbot_thread_value
    }

}

export function isJsonString(str) {
    if (str) {
        let replaceStr = str.replace(/\n(?=\s*[{[(])/g, '').replace(/(?<=[}\])])\n/g, '') // Remove \n before and after starting brackets
        try {
            JSON.parse(replaceStr);
        } catch (e) {
            return false;
        }
        return true;
    }
    return false
}

export function getParseData(data) {
    if (data) {
        let replaceStr = data.replace(/\n(?=\s*[{[(])/g, '').replace(/(?<=[}\])])\n/g, '') // Remove \n before and after starting brackets
        try {
            return JSON.parse(replaceStr);
        } catch (e) {
            return "";
        }
    }
    return ""
}
// export function hexToRgba(hex) {
//     let alpha = 0.2
//     // Remove the hash at the start if it's there
//     hex = hex.replace(/^#/, '');
//     // Parse r, g, b values
//     let r = parseInt(hex.substring(0, 2), 16);
//     let g = parseInt(hex.substring(2, 4), 16);
//     let b = parseInt(hex.substring(4, 6), 16);
//     // Ensure alpha is between 0 and 1
//     if (alpha < 0) alpha = 0;
//     if (alpha > 1) alpha = 1;
//     return `rgba(${r}, ${g}, ${b}, ${alpha})`;
// }
export function hexToRgba(hex, alpha = 0.2) {
    // Remove the hash at the start if it's there
    hex = hex.replace(/^#/, '');

    // Check if the hex value is 3 characters and expand to 6 characters
    if (hex.length === 3) {
        hex = hex.split('').map(char => char + char).join('');
    }

    // Parse r, g, b values
    let r = parseInt(hex.substring(0, 2), 16);
    let g = parseInt(hex.substring(2, 4), 16);
    let b = parseInt(hex.substring(4, 6), 16);

    // Ensure alpha is between 0 and 1
    if (alpha < 0) alpha = 0;
    if (alpha > 1) alpha = 1;

    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}
// export function renderThreadMsg(chatbotThread, textType) {
//     switch (textType) {
//         case "text":
//             return <Markdown
//                 remarkPlugins={[remarkGfm]}
//                 rehypePlugins={[
//                     [rehypeExternalLinks, { target: '_blank', rel: ['noopener', 'noreferrer'] }]
//                 ]}
//                 className={styles.reactMarkdownStyle}>
//                 {chatbotThread?.chatbot_thread_value?.replace(patternToRemoveSource, "")}
//             </Markdown>
//         case "media":
//             return (
//                 <>
//                     {
//                         chatbotThread.media_data.map((media) => {
//                             return (
//                                 <>
//                                     <div style={{ position: "relative" }}>
//                                         <span style={{
//                                             position: "absolute", top: "0", right: "0", background: "#ECEFF1", borderRadius: "20%", padding: "7px"
//                                         }}>
//                                             <a href={media.aws_storage_media_url} download="">
//                                                 <IconsColor iconName='download' width="30px" height="30px" fillColor="#000" />
//                                             </a>
//                                         </span>
//                                         <div style={{ color: "#7A7A7A", marginBottom: "10px" }}><Markdown
//                                             remarkPlugins={[remarkGfm]}
//                                             rehypePlugins={[
//                                                 [rehypeExternalLinks, { target: '_blank', rel: ['noopener', 'noreferrer'] }]
//                                             ]}
//                                         >{media.aws_storage_file_name}</Markdown></div>
//                                         <img className={"clickable imgAWSStyle"}
//                                             loading={"lazy"}
//                                             src={media.aws_storage_media_url} alt="img"
//                                             style={{ width: '100%', height: '100%', borderRadius: "10px" }} />
//                                         <Divider sx={{ margin: "5px 0px", opacity: "0.7", color: "#D5D7DB" }} />
//                                     </div>
//                                 </>
//                             )
//                         })
//                     }
//                     <div><Markdown>{chatbotThread.chatbot_thread_value?.replace(patternToRemoveSource, "")}</Markdown></div>
//                 </>
//     )}}

/**
 * If message is a JSON object with exactly one primitive key/value pair,
 * return markdown bullet text like: `- project name: value`
 * Otherwise return null so the caller can fall back to normal markdown rendering.
 */
const TEXT_TO_HTML_RULES = {
    strike: {
        regex: /<\s*(?:s|del|strike)[^>]*>(.*?)<\s*\/\s*(?:s|del|strike)\s*>|~~(.*?)~~|~([^~\n]+)~/gi,
        replace: (_, a, b, c) => `<s>${a || b || c}</s>`,
    },
    bold: {
        regex: /\*\*(.*?)\*\*|\*([^*\n]+)\*/g,
        replace: (_, a, b) => `<strong>${a || b}</strong>`,
    },
    italic: {
        regex: /_([^_\n]+)_/g,
        replace: '<em>$1</em>',
    },
    bullets: {
        regex: /(^|\n)\s*[-*•]\s+(.*?)(?=\n|$)/g,
        replace: '$1&bull; $2',
    },
    lineBreak: {
        regex: /\n/g,
        replace: "<br/>",
    },
};

export const parseTextToHtml = (text = "") => {
    const ORDER = ["strike", "bold", "italic", "bullets", "lineBreak"];

    let result = String(text ?? "");

    ORDER.forEach(key => {
        const rule = TEXT_TO_HTML_RULES[key];
        result = result.replace(rule.regex, rule.replace);
    });

    return result;
};

export function formatDateTime(dateString, type = "date") {
    const date = new Date(dateString);

    const day = String(date.getDate()).padStart(2, "0");
    const monthNum = String(date.getMonth() + 1).padStart(2, "0");
    const yearFull = date.getFullYear();
    const yearShort = String(yearFull).substring(2);

    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const monthText = months[date.getMonth()];

    let hours = date.getHours();
    const fullFormatHours = String(hours).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const AmPm = hours >= 12 ? "PM" : "AM";

    hours = hours % 12;
    hours = hours ? hours : 12;

    const time = `${hours}:${minutes} ${AmPm}`;
    const time24hrFormat = `${fullFormatHours}:${minutes}`;
    const timeWithUnderscore = `${hours}:${minutes}_${AmPm}`;

    switch (type) {
        case "time":
            return time;

        case "date":
            return `${day}/${monthNum}/${yearShort}`;

        case "dmy":
            return `${day}-${monthNum}-${yearFull}`;
        
        case "dmTextyShort":
            return `${day}-${monthText}-${yearShort}`

        case "dmTexty":
            return `${day} ${monthText} ${yearFull}`;

        case "ymd":
            return `${yearFull}-${monthNum}-${day}`;

        case "dmyTime":
            return `${day}-${monthText}-${yearShort} ${time}`;

        case "dmyNumTime":
            return `${day}-${monthNum}-${yearFull} ${time}`;

        case "dmyTimeFormatWithUnderscore":
            return `${day}-${monthNum}-${yearFull}_${timeWithUnderscore}`;
        
        case "dmy24hrFormat":
            return `${day}-${monthText}-${yearShort} ${time24hrFormat}`;
        
        case "dmyFull24hrFormat":
            return `${day} ${monthText} ${yearFull} ${time24hrFormat}`;

        default:
            return `${day}/${monthNum}/${yearShort}`;
    }
}

export function formatDateAccordingToTimezoneUsingMoment(dateString, timeZone, flag) {
    const dateFormat = "YYYY-MM-DD HH:mm:ss";
    let formattedDate = moment.utc(dateString, dateFormat);

    if (timeZone) {
        const offsetMatch = timeZone.match(/^UTC([+-]\d{1,2}):?(\d{2})?$/);
        if (offsetMatch) {
            const offsetHours = parseInt(offsetMatch[1], 10);
            const offsetMinutes = parseInt(offsetMatch[2] || 0, 10);
            const totalOffsetMinutes = offsetHours * 60 + offsetMinutes;
            formattedDate = formattedDate.utcOffset(totalOffsetMinutes);
        }
    }
    if (flag === "closed") {
        return formattedDate.format("DD-MMM-YY HH:mm");
    }
    else if (flag === "active") {
        return formattedDate.format("HH:mm");
    }
    else if (flag === "campaign") {
        return formattedDate.format("DD-MMM-YY HH:mm:ss");
    }
    else {
        return formattedDate.format("DD-MMM-YY HH:mm");
    }
}

export function isReturningUser(timestamp1, timestamp2) {
    const format = "DD-MMM-YY HH:mm";
    const date1 = moment(timestamp1, format);
    const date2 = moment(timestamp2, format);

    const diffInDays = Math.abs(date1.diff(date2, 'days', true));
    return diffInDays > 1;
}

export const getBrowserTimeZone = () => {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
}

export function formatDateAccordingToTimezone(dateString, timeZone, flag) {
    if (dateString) {
        const [datePart, timePart] = dateString.split(' ');
        const [year, month, day] = datePart ? datePart.split('-') : [];
        const [hours, minutes, seconds] = timePart ? timePart.split(':') : [];

        if (!year || !month || !day || !hours || !minutes) {
            console.log(`Invalid date passed: ${dateString}`);
            return "-";
        }

        const date = new Date(Date.UTC(year, month - 1, day, hours, minutes, seconds));

        if (isNaN(date.getTime())) {
            console.log(`Invalid date passed: ${dateString}`);
            return "-";
        }

        const options = {
            day: '2-digit',
            month: 'short',
            year: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: true,
            timeZone: timeZone || getBrowserTimeZone()
        };

        const locale = 'default';
        const formattedString = date.toLocaleString(locale, options);
        const dateTimeParts = formattedString ? formattedString.split(', ') : [];
        const formattedDate = dateTimeParts.length > 1 ? dateTimeParts[0] + ' ' + dateTimeParts[1] : "";
        const formattedTime = dateTimeParts.length > 2 ? dateTimeParts[2] : "";
        const [formattedMonth, formattedDay, formattedYear] = formattedDate ? formattedDate.split(' ') : [];
        const [formattedHour, formattedMinuteAndAmPm] = formattedTime ? formattedTime.split(':') : [];
        const [formattedMinute, ampm] = formattedMinuteAndAmPm ? formattedMinuteAndAmPm.split(' ') : [];

        if (flag === "closed") {
            return `${formattedDay || '00'}/${formattedMonth || 'MMM'}/${formattedYear || '00'}`;
        } else if (flag === "active") {
            return `${formattedHour || '00'}:${formattedMinute || '00'} ${ampm || 'AM/PM'}`;
        } else {
            return `${formattedDay || '00'}-${formattedMonth || 'MMM'}-${formattedYear || '00'} ${formattedHour || '00'}:${formattedMinute || '00'} ${ampm || 'AM/PM'}`;
        }
    } else {
        console.log(`Invalid date passed: ${dateString}`);
        return "-";
    }
}
export const getFileTypeImgIcon = (fileType) => {
    switch (fileType) {
        case 'txt':
            return textTypeFileIcon
        case 'md':
            return mdTypeFileIcon
        case 'json':
            return jsonTypeFileIcon;
        case 'csv':
            return csvTypeFileIcon;
        case 'png':
            return pngTypeFileIcon;
        case 'jpg':
            return jpgTypeFileIcon;
        case 'xml':
            return xmlTypeFileIcon;
        case 'jpeg':
            return jpegTypeFileIcon;
        default:
            return genericFileType;
    }
}
export const chatbotThemes = [
    {
        "chatbot_theme_name": "Default",
        "chatbot_font_color": secondaryColor,
        "chatbot_back_ground_color": "#FFFFFF",
        "system_msg_color": "#000000",
        "user_msg_color": "#000000",
        "system_msg_bg_color": "#FFF",
        "user_msg_bg_color": secondaryColor,
        // 'chatbot_send_message_bg_color': "#f7e9ff80",
        'chatbot_send_message_bg_color': "#FFF",
        'chatbot_send_message_font_color': "#000000",
        'chatbot_send_message_icon_color': primaryColor,
        'chatbot_header_color': secondaryColor,
        'chatbot_header_font_color': "#000000"

    },
    {
        "chatbot_theme_name": "Dark",
        "chatbot_font_color": "#fff",
        "chatbot_back_ground_color": "#FFF",
        "system_msg_color": "#000",
        "user_msg_color": "#fff",
        "system_msg_bg_color": "#fff",
        "user_msg_bg_color": "#000",
        'chatbot_send_message_bg_color': "#fff",
        'chatbot_send_message_font_color': "#000",
        'chatbot_send_message_icon_color': "#000",
        'chatbot_header_color': "#202C33",
        'chatbot_header_font_color': "#fff"
        // 'chatbot_header_font_color': secondaryColor
    },
    {
        "chatbot_theme_name": "Green",
        "chatbot_font_color": "#000000",
        "chatbot_back_ground_color": "#FFFFFF",
        "system_msg_color": "#000000",
        "user_msg_color": "#000000",
        "system_msg_bg_color": "#fff",
        "user_msg_bg_color": "#D9F1DF",
        'chatbot_send_message_bg_color': "#fff",
        'chatbot_send_message_font_color': "#000000",
        'chatbot_send_message_icon_color': "#11BB4B",
        'chatbot_header_color': "rgba(217, 241, 223, 1)",
        'chatbot_header_font_color': "rgba(14, 174, 69, 1)"
    },
    {
        "chatbot_theme_name": "Blue",
        "chatbot_font_color": "#000000",
        "chatbot_back_ground_color": "#FFFFFF",
        "system_msg_color": "#000000",
        "user_msg_color": "#000000",
        "system_msg_bg_color": "#fff",
        "user_msg_bg_color": "#DAE9FA",
        'chatbot_send_message_bg_color': "#FFFFFF",
        'chatbot_send_message_font_color': "#7A7A7A",
        'chatbot_send_message_icon_color': "#0A6ADD",
        'chatbot_header_color': "#DAE9FA",
        'chatbot_header_font_color': "#0A6ADD"
    },
    {
        "chatbot_theme_name": "Grey",
        "chatbot_font_color": "#000000",
        "chatbot_back_ground_color": "#FFFFFF",
        "system_msg_color": "#000000",
        "user_msg_color": "#000000",
        "system_msg_bg_color": "#fff",
        "user_msg_bg_color": "#F3F3F3",
        'chatbot_send_message_bg_color': "#FFFFFF",
        'chatbot_send_message_font_color': "#000000",
        'chatbot_send_message_icon_color': "#5C5C5C",
        'chatbot_header_color': "#F3F3F3",
        'chatbot_header_font_color': "#5E5E5E"
    },
    {
        "chatbot_theme_name": "Yellow",
        "chatbot_font_color": "#000000",
        "chatbot_back_ground_color": "#FFFFFF",
        "system_msg_color": "#000000",
        "user_msg_color": "#000000",
        "system_msg_bg_color": "#FFF",
        "user_msg_bg_color": "#F9F7E4",
        'chatbot_send_message_bg_color': "#FFFFFF",
        'chatbot_send_message_font_color': "#7A7A7A",
        'chatbot_send_message_icon_color': "#E2BD3A",
        'chatbot_header_color': "#F9F7E4",
        'chatbot_header_font_color': "#E5B91C"
    },
]

function normalizeColor(color) {
    if (color && typeof color == "string") {
        return color.toLowerCase().trim();
    }
}

export const fontColorForMethod = (method) => {
    switch (method?.toLowerCase()) {
        case "get":
            return "#3E8B3E";
        case "post":
            return "#FF9F00";
        case "put":
            return "#00A9E0";
        case "patch":
            return "#8E24AA";
        case "delete":
            return "#E53935";
        default:
            return "#8E8E8E";
    }
} 

export const fontColorForAwaitWebhook = (status) => {
    switch(status.toLowerCase()){
        case 'waiting': 
            return "#FF9F00";
        case 'expired': 
            return "#E53935";
        case 'completed': 
            return "#3E8B3E";
        default: 
            return "#8E8E8E";
    }
}

export function checkForMatchingTheme(state) {
    for (const theme of chatbotThemes) {
        let allMatch = true;

        for (const item of state) {
            if (theme.hasOwnProperty(item.id) && item.id !== "chatbot_theme_name") {
                if (normalizeColor(theme[item.id]) !== normalizeColor(item.value)) {
                    // console.log(`Mismatch found for theme: ${theme.chatbot_theme_name}`);
                    // console.log(`Checking property: ${item.id}, Theme value: ${theme[item.id]}, State value: ${item.value}`);
                    allMatch = false;
                    break;
                }
            }
        }

        if (allMatch) {
            return theme.chatbot_theme_name;
        }
    }
    return null;
}
export function isValidWebsite(website) {
    return /^(https?:\/\/)?(www\.)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(:\d+)?(\/[^\s]*)?$/.test(website);
}

export function flagAccessNotGranted(userDetail, errorCode) {
    if (userDetail.flagUser) {
        if (errorCode === 9020) {
            return true
        } else {
            return false
        }
    } else {
        return false
    }
}
export function flagDataNotFound(userDetail, errorCode) {
    if (userDetail.flagUser) {
        if (errorCode === 9032) {
            return true
        } else {
            return false
        }
    } else {
        return false
    }
}

export const messageFormats = [
    {
        message_format_id: 2,
        message_format_name: "Suggestion for Quick Replies"
    },
    {
        message_format_id: 3,
        message_format_name: "Open URL in new Tab"
    },
    {
        message_format_id: 4,
        message_format_name: "Open URL in iframe in Popup Modal"
    },
    {
        message_format_id: 5,
        message_format_name: "Doctor Cards Carousel"
    },
]

export function formatCallAnalysisTimeAccordingToTimezoneUsingMoment(dateString, timeZone) {
    const dateFormat = "YYYY-MM-DD HH:mm:ss";
    let formattedDate = moment.utc(dateString, dateFormat);

    // if (timeZone) {
    //     const offsetMatch = timeZone.match(/^UTC([+-]\d{1,2}):?(\d{2})?$/);
    //     if (offsetMatch) {
    //         const offsetHours = parseInt(offsetMatch[1], 10);
    //         const offsetMinutes = parseInt(offsetMatch[2] || 0, 10);
    //         const totalOffsetMinutes = offsetHours * 60 + offsetMinutes;
    //         formattedDate = formattedDate.utcOffset(totalOffsetMinutes);
    //     }
    // }

    return formattedDate.format("DD-MM-YY HH:mm");
}
export function convertKeysToLowerCase(obj) {
    if (typeof obj !== 'object' || obj === null) {
        return obj;
    }

    if (Array.isArray(obj)) {
        return obj.map(convertKeysToLowerCase);
    }

    return Object.keys(obj).reduce((acc, key) => {
        const lowerCaseKey = key.toLowerCase();
        acc[lowerCaseKey] = convertKeysToLowerCase(obj[key]);
        return acc;
    }, {});
}
export function extractTime(key) {
    // Check if the key is in the format "2024-09-13T10:00:00.000Z"
    if (typeof key === 'string' && key.includes('T') && key.includes('Z')) {
        // Split the string and extract the time part "10:00"
        return key.split('T')[1].substring(0, 5);
    }
    // If the key is already in "10:00" format or doesn't match the first pattern, return "10:00"
    return key;
}
export function flagShowHomeButton() {
    if (window.location.pathname.toLowerCase() !== "/" && window.location.pathname.toLowerCase() !== "/chatbot" && window.location.pathname.toLowerCase() !== "/inbox" && window.location.pathname.toLowerCase() !== "/feedback" && window.location.pathname.toLowerCase() !== "/channels" && window.location.pathname.toLowerCase() !== "/insights" && window.location.pathname.toLowerCase() !== "/contacts" && window.location.pathname.toLowerCase() !== "/whatsappcampaign" && window.location.pathname.toLowerCase() !== "/whatsappcampaign/dashboard" && window.location.pathname.toLowerCase() !== "/whatsappcampaign/createnewcampaign" && window.location.pathname.toLowerCase() !== "/callanalysis" && window.location.pathname.toLowerCase() !== "/callanalysis" && window.location.pathname.toLowerCase() !== "/workflow" && window.location.pathname.toLowerCase() !== "/customapi" && window.location.pathname.toLowerCase() !== "/webhook" && window.location.pathname.toLowerCase() !== "/customapi/createcustomapi" && window.location.pathname.toLowerCase()) {
        return true
    }
    return false
}
export function sideNavigationNavigateToHomeBlockedRoutes(pathName) {
    const invalidPaths = [
        '/',
        "/chatbot",
        "/inbox",
        "/feedback",
        "/channels",
        "/insights",
        "/contacts",
        "/whatsappcampaign",
        "/whatsappcampaign/dashboard",
        "/whatsappcampaign/createnewcampaign",
        "/callanalysis",
        "/callanalysis/callrecords",
        "/callanalysis/callrecords/newcallrecords",
        "/workflow",
        "/customAPI",
        "/customAPI/createCustomAPI",
        "/webhook",
        "/workflow/staticWorkflowDetails", 
        "/supportTicket",
        "/orderDetails",
        "/conversionLeads",
        "/get-started",
        "/intent",
        "/product",
        "/dashboard", 
        "/knowledge-base",
        "/voiceagent",
    ]
    return invalidPaths.includes(pathName)
}
export function getChannelIcon(channelName) {
    let channel = channelName.toLowerCase()
    switch (channel) {
        case 'instagram':
            return <img alt="instagram" src={instagramIcon} width={"20"} height={"20"} style={{ display: "flex" }} />;
        case 'facebook':
            return <IconsColor iconName="facebook_messenger" height="20" width="20" />
        default:
            return <img alt='whatsapp' src={whatsappIcon} width={"22"} height={"22"} style={{ display: "flex" }} />;
    }
}

export function getBusinessUsername(obj, channelName) {
    let channel = channelName.toLowerCase();
    switch (channel) {
        case 'instagram':
            return obj.instagram_account_name;
        case 'facebook':
            return obj.page_name;
        default:
            return obj.waba_name
    }
}

export const isWhatsAppBusinessApp = (whatsAppIntegration) => {
    if(!whatsAppIntegration) return false;

   return whatsAppIntegration?.meta_integration_phone_number_data?.some((phoneNumberData) => phoneNumberData?.flag_smb_phone_number) ?? false;
}

export function getLinkedChatbotNumbers(obj, channelName) {
    let channel = channelName.toLowerCase();
    switch (channel) {
        case 'instagram':
            return `${obj.chatbot_integration_assignment_data.length} / 1`;
        case 'facebook':
            return `${obj.chatbot_integration_assignment_data.length} / 1`;
        default:
            return `${obj.meta_integration_phone_number_data?.filter((data) => data?.chatbot_integration_assignment_data.length > 0).length} / ${obj?.meta_integration_phone_number_data?.length}`
    }
}

/**
 * @param {string} integration
 * @param {string | number | null} size
 * @param {string} className
 * @param {string | null} defaultIcon
 */

export const getIntegrationIcon = (integration, size, className = "", defaultIcon = null) => {
    const integrationName = integration?.toLowerCase() ?? "";

    const iconProps = size 
        ? {
            height: size,
            width: size
        } : {};
    const classNameProps = className
        ? { className }
        : {};
    
    switch (integrationName) {
        case "slack":
            return <IconsColor iconName="colouredSlackIcon" {...iconProps} />;
        case "calendly":
            return <IconsColor iconName="calendly" {...iconProps} />;
        case "zoho":
            return <img alt="zoho" src={zohoIcon} {...iconProps} {...classNameProps} />;
        case "whatsapp":
            if (size) {
                const whatsappSize = parseInt(size, 10) + 1; // By Default We Increase the Size by 1px for WhatsApp Icon.
        
                iconProps.height = whatsappSize;
                iconProps.width = whatsappSize;
            }
            return <img alt="whatsapp" src={whatsappIcon} {...iconProps} {...classNameProps} />;
        case "facebook":
            return <img alt="facebook" src={facebookIcon} {...iconProps} {...classNameProps} />;
        case "instagram":
            return <img alt="instagram" src={instagramIcon} {...iconProps} {...classNameProps} />;
        case "website":
            return <IconsColor iconName="website" {...iconProps} fill="#93A1A2" />;
        case "chrnoxaiwebapp":
        case "chronoxaiwebapp":
            return <img alt="chronoxIcon" src={chronoxIcon} {...iconProps} {...classNameProps} />;
        default:
            if (defaultIcon) {
                return <img alt="defaultIcon" src={defaultIcon} {...iconProps} {...classNameProps} />;
            }
            return <></>;
    }
}

export function showWorkspaceBlock(pathName) {
    const validPaths = [
        "/",
        "/insights",
        "/chatbot",
        "/inbox",
        "/channels",
        "/supportticket",
        "/contacts",
        "/whatsappcampaign",
        "/whatsappcampaign/dashboard",
        "/whatsappcampaign/createnewcampaign",
        "/workflow",
        "/workflow/staticworkflowdetails",
        "/customapi",
        "/customapi/createcustomapi",
        "/webhook",
        "/analytics",
        "/callanalysis",
        "/callanalysis/callrecords",
        "/callanalysis/callrecords/newcallrecords",
        "/orderdetails", 
        "/conversionleads",
        "/get-started",
        "/intent",
        "/product",
        "/dashboard", 
        "/knowledge-base",
        "/voiceagent",
    ];

    return validPaths.includes(pathName);
}

export function breadCrumbPathName(pathname) {
    const validpaths = [
        "/",
        "/chatbot",
        "/customapi",
        "/customapi/createcustomapi",
        "/webhook",
        "/callanalysis",
        "/callanalysis/callrecords",
        "/callanalysis/callrecords/newcallrecords",
        "/inbox",
        "/contacts",
        "/supportticket",
        "/insights",
        "/whatsappcampaign",
        "/whatsappcampaign/dashboard",
        "/whatsappcampaign/createnewcampaign",
        "/channels",
        "/workflow",
        "/orderdetails", 
        "/conversionleads",
        "/knowledge-base",
        "/workflow/staticworkflowdetails",
        "/get-started",
        "/intent",
        "/product",
        "/dashboard",
    ];

    return validpaths.includes(pathname);
}

export function getCurrentActiveMenu(pathname) {
    const pathMapping = {
        "/": "AI Chatbot",
        "/chatbot": "AI Chatbot",
        "/supportTicket": "Support Tickets",
        "/insights": "Dashboard",
        "/createchatbot": "Create Chatbot",
        "/whatsappcampaign": "WhatsApp Campaign",
        "/whatsappcampaign/createnewcampaign": "Create New Campaign",
        "/settings-accountdetails": "Settings",
        "/settings-plansandbilling": "Settings",
        "/chatbot/viewchatbot/basicdetail": "Basic Details",
        "/chatbot/viewchatbot": "Basic Details",
        "/chatbot/viewchatbot/integration": "Integrations",
        "/chatbot/viewchatbot/createintegration": "Create Integration",
        "/chatbot/viewchatbot/channels/whatsapp": "WhatsApp",
        "/chatbot/viewchatbot/channels/facebook": "FB Messenger",
        "/chatbot/viewchatbot/channels/instagram": "Instagram",
        "/chatbot/viewchatbot/channels/website": "Website",
        "/chatbot/viewchatbot/channels/slack": "Slack",
        "/chatbot/viewchatbot/trychatbot": "Try Chatbot",
        "/chatbot/viewchatbot/inbox": "Inbox",
        "/inbox": "Inbox",
        "/chatbot/viewchatbot/persistentmenu": "Persistent Menu",
        "/chatbot/viewchatbot/products": "Products",
        "/channels": "Channels",
        "/channels/viewintegration/whatsapp": "Account Setup",
        "/channels/viewintegration/whatsapp/phonenumbers": "Phone Numbers",
        "/channels/viewintegration/whatsapp/phonenumbers/customrecipient": "Phone Numbers",
        "/channels/viewintegration/whatsapp/templatemessages": "Template Messages",
        "/channels/viewintegration/whatsapp/legacy/templateinfo": "New Template Message",
        "/channels/viewintegration/whatsapp/templatelibrary": "Template Library",
        "/channels/viewintegration/facebook": "Account Setup",
        "/channels/viewintegration/facebook/pages": "Pages",
        "/channels/viewintegration/facebook/templatemessages": "Template Messages",
        "/channels/viewintegration/facebook/templateinfo": "Template Messages",
        "/channels/viewintegration/instagram": "Account Setup",
        "/channels/viewintegration/slack": "Account Setup",
        "/channels/viewintegration/slack/channels": "Slack Channels",
        "/callanalysis": "Dashboard",
        "/callanalysis/callrecords": "Call Records",
        "/callanalysis/callrecords/newcallrecords": "New Call Records",
        "/organization": "Workspace",
        "/channels/viewintegration/whatsapp/flows": "WhatsApp Flows",
        "/channels/viewintegration/whatsapp/flowdetails": "WhatsApp Flows",
        "/channels/viewintegration/whatsapp/paymentconfiguration": "Payment Configuration",
        "/channels/viewintegration/whatsapp/carouseltemplategroups": "Carousel Template Groups"
    }
    return pathMapping[pathname]
}
export const generateUUID = () => {
    return uuidv4();
}
export const sidePanelWidth = 250 //233 prev

export function getWhatsappMediaSizeLimit(mediaType) { //in mb
    let mediaTypeInLowerCase = mediaType.toLowerCase()
    //  This Media Size Limit is based on this Official meta documents: https://developers.facebook.com/docs/whatsapp/cloud-api/reference/media#supported-media-types
    switch (mediaTypeInLowerCase) {
        case 'image':
            return 5;
        case 'video':
            return 16;
        case 'audio':
            return 16;
        case 'document':
            return 100;
        default:
            return 3
    }
}

export function getWhatsappMediaAllowedFileTypes(mediaType) {
    let mediaTypeInLowerCase = mediaType.toLowerCase()
    //  This media type is based on this Official meta documents: https://developers.facebook.com/docs/whatsapp/cloud-api/reference/media#supported-media-types
    switch (mediaTypeInLowerCase) {
        case 'image':
            return {
                displayTypeToUser: "JPG, JPEG, PNG", 
                allowedType: '.jpg, .jpeg, .png, image/jpeg, image/jpg,  image/png',
            }
        case 'video': 
            return {
                displayTypeToUser: "MP4, 3GP",
                allowedType: '.mp4, .3gp, video/mp4, video/3gpp',
            }
        case 'audio': 
            return {
                displayTypeToUser: "", 
                allowedType: '.aac, audio/aac, .amr, audio/amr, .mp3, audio/mpeg, .m4a, audio/mp4, .ogg, audio/ogg',
            }
        case 'document': 
            return {
                displayTypeToUser: "PDF",
                allowedType: '.pdf, application/pdf'
            }
        default:
            return {
                displayTypeToUser: "", 
                allowedType: "",
            }
    }
}

export function replacingTemplateMarkdownText(text) {
    text = text?.replace(/\*(.*?)\*/g, '<b>$1</b>');  // Bold
    // text = text?.replace(/_(.*?)_/g, '<i>$1</i>');    // Italic
    text = text?.replace(/(?<!\w)_(.*?)_(?!\w)/g, '<i>$1</i>'); // Italic
    text = text?.replace(/~(.*?)~/g, '<s>$1</s>');    // Strikethrough
    text = text?.replace(/```(.*?)```/g, '<code>$1</code>');  // Monospace
    text = text?.replace(/\\n/g, '<br>');

    return text;
}

export const getWabaName = (integrationListNewStructure, integrated_channel_id, defaultWabaName) => {
    let waba_name = defaultWabaName;
    if (integrationListNewStructure) {
        const obj = integrationListNewStructure.find((list) => list.integrated_channel_id == integrated_channel_id);
        if (obj) {
            if ("waba_name" in obj) {
                waba_name = obj.waba_name;
            }
        }
    }
    return waba_name;
}

export const getPhoneNumber = (integrationListNewStructure, integrated_channel_id, phoneNumberId, defaultPhoneNumber) => {
    let phone_number = defaultPhoneNumber;
    if (integrationListNewStructure) {
        const obj = integrationListNewStructure.find((list) => list.integrated_channel_id == integrated_channel_id);
        if (obj) {
            if ("meta_integration_phone_number_data" in obj) {
                const selectedPhoneNumber = obj.meta_integration_phone_number_data?.find((phone) => phone.phone_number_id == phoneNumberId);
                if (selectedPhoneNumber) {
                    phone_number = selectedPhoneNumber.display_phone_number;
                }
            }
        }
    }
    return phone_number;
}
export function convertToSchema(obj) {
    const getType = (value) => {
        if (Array.isArray(value)) return 'array';
        if (value === null) return 'string'; // Treat nulls as strings in schema
        return typeof value;
    };

    const processObject = (obj) => {
        const schema = {
            type: 'object',
            properties: {},
            required: [],
        };

        for (const key in obj) {
            const value = obj[key];
            const valueType = getType(value);

            schema.required.push(key);

            if (valueType === 'object' && value !== null && !Array.isArray(value)) {
                schema.properties[key] = processObject(value);
            } else if (valueType === 'array') {
                schema.properties[key] = {
                    type: 'array',
                    items: Array.isArray(value) && value.length && typeof value[0] === 'object'
                        ? processObject(value[0])
                        : { type: 'string', description: key },
                };
            } else {
                schema.properties[key] = {
                    type: 'string',
                    description: key,
                };
            }
        }

        return schema;
    };

    return processObject(obj);

}

export const isDelegateAccessFlagTrue = (userDetails) => {
    if (userDetails?.flagUser && userDetails?.user_delegate_access_flag) return true;
    return false;
} 

export const onClickOfFlowButton = (subBtnData, WabaID) => {
    if(String(subBtnData?.whatsapp_template_button_sub_type_id) == "7"){ 
        const selectedFlow = subBtnData?.whatsapp_template_button_sub_type_field_data?.find((field) => field?.field_name?.toLowerCase() == "flow");
        if(selectedFlow && selectedFlow?.whatsapp_template_button_sub_type_field_value){
            window.open(`/channels/viewintegration/whatsapp/flowDetails?id=${WabaID}&flow_id=${selectedFlow?.whatsapp_template_button_sub_type_field_value}`, "_blank");
        }
    }
} 

export const getMenuNameOfMainMenu = (menuName, isMenuOpen) => {
    if(menuName == "Show More/Less"){
        if(isMenuOpen){
            return "Show Less";
        } else {
            return "Show More"
        }
    } else {
        return menuName;
    }
}

export const checkValidRegex = (conditionValue) => {
    try {
        new RegExp(conditionValue);
        return true; // Valid Regex
    } catch {
        return false;
    }
}

export const isNewUser = (user_registered_timestamp) => {
    const registeredDate = new Date(user_registered_timestamp); 

    const fixedDay = new Date("2025-09-10T00:00:00.000z"); // Date : 10/09/2025

    return registeredDate.getTime() >= fixedDay.getTime();
} 

export const flagShowGetStartedPage = (userDetail) => {
    return (userDetail?.user_registered_timestamp && isNewUser(userDetail?.user_registered_timestamp) && !userDetail?.flag_onboarded);
}

export function formatString(str) { // Convert this type of string "reply_buttons" to "Reply Buttons". Mainly used in interactive type.
    return str?.replace(/_/g, ' ')?.split(' ')?.map(word => word?.charAt(0)?.toUpperCase() + word?.slice(1))?.join(' ');
} 

export const formatFileSize = (bytes, decimalPoint) => {
    if (bytes == 0) return '';
    var k = 1000,
        dm = decimalPoint || 2,
        sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
        i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}

export function thousandSeparator (value) {
    return value?.toLocaleString();
}

export const checkOrganizationRole = (userDetail, role_name) => {
    if(userDetail && userDetail?.user_organization_data && userDetail?.user_organization_data?.user_organization_role_name && userDetail?.user_organization_data?.user_organization_role_name?.toLowerCase() == role_name?.toLowerCase()){
        return true;
    } 
    return false;
}

export const isOrganizationRoleAgent = (userDetail) => {
    return checkOrganizationRole(userDetail, ORGANIZATION_ROLES["AGENT_ROLE"]);
}

export const checkUserAssignmentRole = (userDetail, roleName) => {
    const role = userDetail?.user_assignment_role_data?.[0]?.chronox_user_role_name ?? "";
    return role?.toLowerCase() == roleName?.toLowerCase();
}

export const isAgentOrAdmin = (userDetail) => {
    return checkUserAssignmentRole(userDetail, USER_ASSIGNMENT_ROLES["AGENT_ROLE"]) || checkUserAssignmentRole(userDetail, USER_ASSIGNMENT_ROLES["AGENT_ADMIN_ROLE"]);
}

export const getDisplayWabaFieldKeyName = (rawKeyName = "") => {
  if (!rawKeyName) return "";

  let normalizedKey = rawKeyName.toLowerCase().replaceAll(" ", "_");

  normalizedKey = normalizedKey.replaceAll("waba", "whatsapp_business");

  const knownDisplayNames = {
    verified_name: "Business Name",
    display_phone_number: "Phone Number"
  };

  if (knownDisplayNames[normalizedKey]) {
    return knownDisplayNames[normalizedKey];
  }

  let formattedLabel = normalizedKey?.split("_")?.map(word => word?.charAt(0)?.toUpperCase() + word?.slice(1))?.join(" ");

  formattedLabel = formattedLabel.replace(/Whatsapp Business/gi, "WhatsApp Business");

  return formattedLabel;
};

export const checkIfBtnDynamicVarExist = (button) => {
    return button?.some(btn =>
        btn?.whatsapp_template_button_data.some(data =>
            data?.whatsapp_template_button_sub_type_field_data.some(field =>
                field?.whatsapp_template_button_field_data_variable &&
                field?.whatsapp_template_button_field_data_variable.length > 0
            )
        )
    );
}

export const flagShowBodyVariableForCarouselTemplate = (whatsapp_template_carousel_variation_id, messageTemplateDetail) => {
    const currentCard = messageTemplateDetail?.whatsapp_template_data?.find((template) => template.whatsapp_template_carousel_variation_id == whatsapp_template_carousel_variation_id); 
    return (currentCard && currentCard?.whatsapp_template_body && currentCard?.whatsapp_template_body?.whatsapp_template_body_variable_data?.length > 0);
} 

export const flagShowButtonVariableForCarouselTemplate = (whatsapp_template_carousel_variation_id, messageTemplateDetail) => {
    const currentCard = messageTemplateDetail?.whatsapp_template_data?.find((template) => template.whatsapp_template_carousel_variation_id == whatsapp_template_carousel_variation_id);
    return (currentCard && currentCard?.whatsapp_template_button && currentCard?.whatsapp_template_button?.length > 0 && checkIfBtnDynamicVarExist(currentCard?.whatsapp_template_button));
}

export const flagShowCarouselGlobalHeaderVariable = (messageTemplateDetail) => {
    return (messageTemplateDetail?.whtatsapp_carousel_header_variable_data && messageTemplateDetail?.whtatsapp_carousel_header_variable_data?.length > 0);
}


export const isGetStartedPageActive = () => {
    const pathName = window.location.pathname.toLowerCase();
    if(pathName == "/" || pathName == "/get-started"){
        return true;
    } 
    return false;
}

export const CHATBOT_CHANNEL_STYLE_CLASS = {
    CHANNEL_THEMED: "channelThemed",
    ACTIVE_THEMED: "activeTriggerNodeThemed",
}

export const phoneNumberQrText = (phoneNumberQR, message) => {
    const encodedMsg = message ? encodeURIComponent(message)  : ''
    return `https://wa.me/%2B${phoneNumberQR.replaceAll("-", "").replaceAll(" ", "").replaceAll("+", "")}?text=${encodedMsg}`;
};

export const instagramQrText = (instagramUsername) => {
    const instaUsername = String(instagramUsername || "");
    return `https://ig.me/m/${instaUsername.replace(/^@/, "")}`;
};

export const getChannelQrText = (value, channelName, message) => {

    const channelNameInLowerCase = channelName?.toLowerCase() || "";

    switch(channelNameInLowerCase) {
        case CHATBOT_CHANNEL_NAME.INSTAGRAM?.toLowerCase():
            return instagramQrText(value);
        case CHATBOT_CHANNEL_NAME.WHATSAPP?.toLowerCase():
            return phoneNumberQrText(value, message);
        default:
            return "";
    }
};

export const  toCapitalizedCase = (str) => {
  if (!str) return "";
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

export const isOrganizationRoleOwner = (userDetail) => {
    return checkOrganizationRole(userDetail, ORGANIZATION_ROLES["OWNER_ROLE"]);
}    

export const isOrganizationRoleAdminOrOwnerOrMember = (userDetail) => {
    return checkOrganizationRole(userDetail, ORGANIZATION_ROLES["OWNER_ROLE"]) || checkOrganizationRole(userDetail, ORGANIZATION_ROLES["ADMIN_ROLE"]) || checkOrganizationRole(userDetail, ORGANIZATION_ROLES["MEMBER_ROLE"]);
}

export const isChatbotTextDirectionLtr = (chatBotDetails) => {
    return chatBotDetails?.chatbot_text_direction?.toLowerCase() == "ltr";
}

export const miliSecondsToHMS = (ms) => {
    let totalSeconds = Math.floor(ms / 1000);

    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    const pad = (n) => String(n).padStart(2, "0");

    return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
}

export const convertMiliSecondsToDuration = (ms) => {
    const totalMinutes = Math.floor(ms / 60000);

    const days = Math.floor(totalMinutes / (24 * 60));
    const hours = Math.floor((totalMinutes % (24 * 60)) / 60);
    const minutes = totalMinutes % 60;

    return { days, hours, minutes };
}

export const convertDurationToMiliSeconds = (days, hours, minutes) => {
    return (days * 24 * 60 * 60 * 1000) + (hours * 60 * 60 * 1000) + (minutes * 60 * 1000);
}

export const getContactListPageUrl = (contact_list_id) => {
    return `${window.location.origin}/contacts?contact_list_id=${contact_list_id}`;
}

export const getValueOrDefault = (value) => {
    return value ?? "-";
}

export const isValidCssColor = (color) => {
    const s = new Option().style;
    s.color = color;
    return s.color !== "";
}; 

export const getUserFullName = (user) => {
    const firstName = user?.private_user_first_name;
    const lastName = user?.private_user_last_name;
    const email = user?.private_user_email;

    if(firstName || lastName) {
        return `${firstName || ""} ${lastName || ""}`?.trim();
    }
    return email || '';
}

export const GENERIC_STATUS = {
    REGISTERED: 'Registered',
    ACTIVE: 'Active',
    DRAFT: 'Draft',
    DELETE: 'Delete',
    INACTIVE: 'Inactive',
    PUBLISHED: 'Published',
    PAUSED: 'Paused',
    PENDING: 'Pending',
    VERIFIED: 'Verified',
    ARCHIVED: 'Archived',
    IMPORTING: 'Importing',
    FAILED: "Failed",
}

export const toScreamingSnakeCase = (str) => {
    return str?.trim()?.replace(/\s+/g, "_")?.toUpperCase();
}

export const CHRONOX_FEATURES = {
    THREAD_TICKETING: 'thread_ticketing'
}

export const isFeatureDisabled = (userDetail, featureName) => {
    const feature = userDetail?.user_organization_feature_disabled?.find((feature) => feature?.chronox_feature_name === featureName);
    
    if(feature) return true;
    return false;
}

export const ORGANIZATION_STATUS_NAME = {
    ACTIVE: "Active",
    PAUSED: "Paused",
}

export const isValidWabaId = (wabaId, integrationListNewStructure) => {
    if (!wabaId || !integrationListNewStructure) {
        return false;
    }

    return integrationListNewStructure.some(
        (list) => ("meta_integration_whatsapp_id" in list) && String(list?.meta_integration_whatsapp_id) === String(wabaId)
    );
}

export const getNestedValue = (obj, path) => {
    return path?.replace(/\?\./g, '.')?.split('.')?.reduce((acc, key) => acc?.[key], obj);
};

export const filterAutocompleteOptionsWithException = (options, state, filterKey, alwaysIncludeKey, alwaysIncludeValue = -1) => {

    const input = state?.inputValue?.toLowerCase() ?? '';
    const filterKeys = Array.isArray(filterKey) ? filterKey : [filterKey];

    return options.filter((option) => {
      if (String(option?.[alwaysIncludeKey]) === String(alwaysIncludeValue)) return true;

        return filterKeys.some((key) => {
            const filterValue = getNestedValue(option, key) ?? '';
            return String(filterValue)?.toLowerCase().includes(input);
        })
    });
};

export const WHATSAPP_WEBHOOK_PAYLOAD_KEY_TYPES = {
    WA_CATALOG: 'wa_catalog',
    WA_PAYMENT: 'wa_payment',
}

export const WHATSAPP_PAYMENT_INFO_SYSTEM_API = 'SendOrderPaymentInfo';

export const isSystemApi = (functionPath) => {
    if(functionPath && functionPath?.length > 0) return true;
    return false;
}

export const addCustomKnowledgeBaseOption = (knowledgeBaseFiles) => {
    const emptyKnowledgeBaseFileObj = {
        knowledge_base_file_id: "-1",
        file_name: "Knowledge Base File",
    }
    return knowledgeBaseFiles ? [...knowledgeBaseFiles, emptyKnowledgeBaseFileObj] : [emptyKnowledgeBaseFileObj];
}

export const AI_LLM_PLATFORMS = {
    OPENAI: 'OpenAI',
    AZURE_OPENAI: 'Azure OpenAI',
    AZURE_FOUNDRY: 'Azure Foundry'
}

export const DEFAULT_MODELS_BASED_ON_AI_LLM_PLATFORM = {
    OPENAI: 'gpt-4o',
    AZURE_OPENAI: 'gpt-4o',
    AZURE_FOUNDRY: 'gpt-5.4-nano'
}

export const filterGptModelsBasedOnAILLMPlatform = (gptModelList, AILLMPlatformList, flagAzure, flagAzureAgent) => {
    let AILLMPlatform = AI_LLM_PLATFORMS['OPENAI'];
    if(flagAzure) AILLMPlatform = AI_LLM_PLATFORMS['AZURE_OPENAI'];
    if(flagAzureAgent) AILLMPlatform = AI_LLM_PLATFORMS['AZURE_FOUNDRY'];

    const getAILLMPlatform = AILLMPlatformList?.find((platform) => platform?.ai_llm_platform_name === AILLMPlatform);
    if(getAILLMPlatform){
        return gptModelList?.filter((model) => model?.ai_llm_platform_id === getAILLMPlatform?.ai_llm_platform_id);
    }
    return gptModelList;
}

export const sortListByRecentTimestamp = (list, timestampKey) => {
    return list?.sort((a, b) => {
        return new Date(b?.[timestampKey]).getTime() - new Date(a?.[timestampKey]).getTime();
    })
}

export const isWaSmbUser = (email) => {
    return email?.toLowerCase() === "wa_smb_user";
}

export const getValidUrl = (url) => {
    try {
        return new URL(url).href;
    } catch {
        return new URL(`https://${url}`).href;
    }
}

export const FACEBOOK_LOGIN_SCOPE = "pages_show_list, pages_messaging, pages_manage_metadata, business_management"

export const INSTAGRAM_LOGIN_SCOPE = "instagram_basic, instagram_manage_messages, business_management, pages_show_list, pages_read_engagement, instagram_manage_comments"

export const checkInternetConnection = () => {
    if (!navigator.onLine) {
      const { showError } = useGenericStore.getState();
        showError("No internet connection. Please check your network and try again.");
        return false;
    }

    return true;
} 

export const extractIntegrationsFromResponse = (data) => {
    const integrationList = data.flatMap((item) => {
        const whatsappIntegrations = item?.meta_integration_whatsapp_data.map((integration) => ({
            ...integration,
            integrated_channel_id: integration.meta_integration_whatsapp_id,
            channel_name: 'Whatsapp',
        }));

        const facebookIntegrations = item?.meta_integration_facebook_data;
        const instagramIntegrations = item?.meta_integration_instagram_data;

        return [
            ...whatsappIntegrations,
            ...facebookIntegrations,
            ...instagramIntegrations
        ]
    });

    return integrationList;
}

export const wabaVerificationDocuments = [
    'Certificate of Incorporation',
    'Business Registration or License',
    'Tax Certificate',
    'Business Bank Statement',
    'Utility Bill'
];

export const isVendor = (vendorData, userDetail) => {
    return vendorData?.vendor_id || userDetail?.user_organization_data?.vendor_id;
}

export const getVendorCompanyName = (vendorData) => {
    return getVendorField(vendorData, 'Company Name', 'Chronox AI');
}

export const restrictedOrganizationIdsForBillingUsageManage = [
    // Clients
    2629, // Wonderwraps
    2574, // HealthTrack
    2584, // Unity Homes
    2664, // Suraj Cineplex
    2606, // Noble Builders
    2344, // Green My Experience
    2569, // Mawhiba
    2545, // Aapdu Junagadh
    2582, // Tim Safransky
    3420, // Shreerao Garment Mart
    3273, // Krunal Sheth
    
    // Vendor
    2637, // Icebolethu
]; 

export const isOrganizationStatus = (userDetail, statusName) => {
    return userDetail?.user_organization_data?.organization_status_name?.toLowerCase() === statusName?.toLowerCase();
};

export const filterChatbotsByFlagPublic = (chatbotList, chatbotFlagPublic) => {
    return chatbotList?.filter((chatbot) => chatbot?.chatbot_flag_public === chatbotFlagPublic);
}

export const filterCustomChatbots = (chatbotList) => {
    return filterChatbotsByFlagPublic(chatbotList, false);
}

export const filterSampleChatbots = (chatbotList) => {
    return filterChatbotsByFlagPublic(chatbotList, true);
}

export const isStagingEnv = () => {
    return process.env.REACT_APP_ENV?.toLowerCase() === "staging";
}
